import React from "react";

import { Button, Col, FormLabel, Row, Table } from "react-bootstrap";
import { AppContext } from "../AppContext.js";
import { NEW_ENTRY } from "../ds/App_Constants.js";
import { NodeData } from "../ds/client_ds.js";
import {
  AddressBean,
  AttributeCacheBean,
  PageListBean,
  RestEntityUnLockRequest,
  RestReadRequest,
  RestVendorFactoryListRequest,
  RestVendorFactoryReadRequest,
  RestVendorListRequest,
  VendorBean,
  VendorFactoryBean,
  VendorFactorySearchCriteria,
  VendorSearchCriteria,
  FabricStyleSearchCriteria,
  RestPageListBean,
  RestFabricStyleListBeanRequest,
  SalesAndPurchaseInquiryCriteriaBean,
} from "../ds/ds.js";
import { DropDwnDown, DropDwnUp } from "../gui_components/Icons.js";
import { BaseBean, RestReportBean } from "../ds/client_ds.js";
import { ReportService } from "../services/ReportService.js";
import { ConfigManager } from "../config/ConfigManager.js";
import {
  AlertToolBox,
  InputCheckbox,
  InputTextbox,
  MultiViewPopup,
  NumberFormatInputbox,
  ShortCutMenuPopup,
  ShowError,
  ColumnDefinition
} from "../gui_components/UIComponents.js";
import {
  isEmpty,
  isEmptyArray,
  isEmptyString,
} from "../gui_components/Util.js";
import {
  PopupVendorOnOrderInq,
  PopupVendorPurchaseHistoryInq,
} from "../Inquiry/InquiryUtil.js";
import {
  PopupPurchaseReceiptModule,
  PopupPurchaseOrderModule
} from "../modules/ModuleUtil.js";
import { GenericAttributeLookupHandler } from "../lookup/GenericAttributeLookupHandler.js";
import { VendorLookupHandler } from "../lookup/VendorLookupHandler.js";
import { SecurityAccessManager } from "../security/SecurityAccessManager.js";
import { VendorService } from "../services/VendorService.js";
import { BaseNodeBar, BaseToolBar, ModuleToolBar } from "./BaseModule.js";
import { CustomerLookupHandler } from "../lookup/CustomerLookupHandler";
import { FabricStyleService } from "../services/FabricStyleService.js";
import { FabricStyleLookupHandler } from "../lookup/FabricStyleLookupHandler.js";
import CustomTable from "../gui_components/CustomTable.js";
import { ModuleUtils } from "./ModuleUtils.js";
import {
  AlignStartVertical,   // ← Header
  Factory,              // ← VendorFactory
  ShoppingBag,          // ← Vendor Purchase Details
} from "lucide-react";
class VendorEntryForm extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      showHide: this.props.showHide,
      vendorData: this.props.vendorData,
      addressData: this.props.addressData,
      wareHouses: this.props.wareHouses,
      currencies: this.props.currencies,
      paymentMethods: this.props.paymentMethods,
      paymentTerms: this.props.paymentTerms,
      vendorTerms: this.props.vendorTerms,
    };

    this.fobCityRef = React.createRef();
    this.warehouseRef = React.createRef();
    this.paymentTermRef = React.createRef();
    this.shipmentTermRef = React.createRef();
    this.shipViaRef = React.createRef();
    this.vendorTermRef = React.createRef();
    this.currencyRef = React.createRef();
    this.countryRef = React.createRef();
    this.incoTermRef = React.createRef();
    this.transportTypeRef = React.createRef();
    this.cityRef = React.createRef();
    this.stateRef = React.createRef();
    this.vendorNameRef = React.createRef();
    this.activeRef = React.createRef();
    this.categoryRef = React.createRef();
    this.vendorTypeRef = React.createRef();
  }

  componentDidMount() {
    this.initLookupHandlers();
    this.setFocus();
  }
  setFocus = () => {
    this.vendorNameRef.current.focus();
  };
  initLookupHandlers = () => {
    let paymentTermLookupHandler = new GenericAttributeLookupHandler(
      this.props.paymentTerms,
      "Payment Term"
    );
    this.setState({ paymentTermLookupHandler: paymentTermLookupHandler });

    let warehouseLookupHandler = new GenericAttributeLookupHandler(
      this.props.wareHouses,
      "Warehouse"
    );
    this.setState({ warehouseLookupHandler: warehouseLookupHandler });

    let shipmentTermLookupHandler = new GenericAttributeLookupHandler(
      this.props.shipmentTerms,
      "ShipmentTerms"
    );
    this.setState({ shipmentTermLookupHandler: shipmentTermLookupHandler });

    let fobCityLookupHandler = new GenericAttributeLookupHandler(
      this.props.fOBCities,
      "FobCity"
    );
    this.setState({ fobCityLookupHandler: fobCityLookupHandler });

    let vendorTermLookupHandler = new GenericAttributeLookupHandler(
      this.props.vendorTerms,
      "VendorTerm"
    );
    this.setState({ vendorTermLookupHandler: vendorTermLookupHandler });

    let currencyLookupHandler = new GenericAttributeLookupHandler(
      this.props.currencies,
      "Currency"
    );
    this.setState({ currencyLookupHandler: currencyLookupHandler });

    let countryLookupHandler = new GenericAttributeLookupHandler(
      this.props.countries,
      "Country"
    );
    this.setState({ countryLookupHandler: countryLookupHandler });

    let incoTermLookupHandler = new GenericAttributeLookupHandler(
      this.props.incoTerms,
      "IncoTerm"
    );
    this.setState({ incoTermLookupHandler: incoTermLookupHandler });

    let transportTypeLookupHandler = new GenericAttributeLookupHandler(
      this.props.transportTypes,
      "TransportType"
    );
    this.setState({ transportTypeLookupHandler: transportTypeLookupHandler });
    let shipViaLookupHandler = new GenericAttributeLookupHandler(
      this.props.shipVias,
      "ShipVia"
    );
    this.setState({ shipViaLookupHandler: shipViaLookupHandler });

    let cityLookupHandler = new GenericAttributeLookupHandler(
      this.props.cities,
      "City"
    );
    this.setState({ cityLookupHandler: cityLookupHandler });

    let stateLookupHandler = new GenericAttributeLookupHandler(
      this.props.states,
      "State"
    );
    this.setState({ stateLookupHandler: stateLookupHandler });

    let categoryLookupHandler = new GenericAttributeLookupHandler(
      this.props.vendorCategories,
      "VendorCategory"
    );
    this.setState({ categoryLookupHandler: categoryLookupHandler });

    let vendorTypeHandler = new GenericAttributeLookupHandler(
      this.props.vendorTypes,
      "VendorType"
    );
    this.setState({ vendorTypeHandler: vendorTypeHandler });
  };
  componentDidUpdate() {
    //
  }
  onChange = (e) => {
    let temp_vendorData = this.props.vendorData;
    if (e.target.name == "description") {
      temp_vendorData["description"] = e.target.value.toUpperCase();
    } else {
      temp_vendorData[e.target.name] = e.target.value;
    }

    let temp_addressData = this.props.addressData;
    if (
      e.target.name == "address1" ||
      e.target.name == "address2" ||
      e.target.name == "address3" ||
      e.target.name == "address4" ||
      e.target.name == "city" ||
      e.target.name == "state" ||
      e.target.name == "country" ||
      e.target.name == "zip" ||
      e.target.name == "mobilePhone" ||
      e.target.name == "phone1" ||
      e.target.name == "phone2" ||
      e.target.name == "contactPerson" ||
      e.target.name == "fax" ||
      e.target.name == "email" ||
      e.target.name == "website"
    ) {
      temp_addressData[e.target.name] = e.target.value;
    }
    this.setState({
      vendorData: temp_vendorData,
      addressData: temp_addressData,
    });
  };
  onCityChange = (e) => {
    this.props.onCityChange(e);
  };
  cityEnterKeyEvent = (e) => {
    this.props.cityEnterKeyEvent(e);
  };
  displayAutoCompleteCityList = (e) => {
    this.props.displayAutoCompleteCityList(e);
  };
  onStateChange = (e) => {
    this.props.onStateChange(e);
  };
  stateEnterKeyEvent = (e) => {
    this.props.stateEnterKeyEvent(e);
  };
  displayAutoCompleteStateList = (e) => {
    this.props.displayAutoCompleteStateList(e);
  };
  onCountryCodeChange = (e) => {
    this.props.onCountryCodeChange(e);
  };
  countryCodeEnterKeyEvent = (e) => {
    this.props.countryCodeEnterKeyEvent(e);
  };
  displayAutoCompleteCountryCodeList = (e) => {
    this.props.displayAutoCompleteCountryCodeList(e);
  };
  onCountryChange = (e) => {
    this.props.onCountryChange(e);
  };
  countryEnterKeyEvent = (e) => {
    this.props.countryEnterKeyEvent(e);
  };
  displayAutoCompleteCountryList = (e) => {
    this.props.displayAutoCompleteCountryList(e);
  };
  onCurrencyCodeChange = (e) => {
    this.props.onCurrencyCodeChange(e);
  };
  currencyCodeEnterKeyEvent = (e) => {
    this.props.currencyCodeEnterKeyEvent(e);
  };
  displayAutoCompleteCurrencyList = (e) => {
    this.props.displayAutoCompleteCurrencyList(e);
  };
  onVendorTypeChange = (e) => {
    this.props.onVendorTypeChange(e);
  };
  vendorTypeEnterKeyEventHandler = (e) => {
    this.props.vendorTypeEnterKeyEventHandler(e);
  };
  displayAutoCompleteVendorTypeList = (e) => {
    this.props.displayAutoCompleteVendorTypeList(e);
  };
  onShipViaChange = (e) => {
    this.props.onShipViaChange(e);
  };
  shipViaEnterKeyEvent = (e) => {
    this.props.shipViaEnterKeyEvent(e);
  };
  displayAutoCompleteShipViaList = (e) => {
    this.props.displayAutoCompleteShipViaList(e);
  };
  onLocationChange = (e) => {
    this.props.onLocationChange(e);
  };
  locationEnterKeyEventHandler = (e) => {
    this.props.locationEnterKeyEventHandler(e);
  };
  displayAutoCompleteLocationList = (e) => {
    this.props.displayAutoCompleteLocationList(e);
  };
  onCategoryChange = (e) => {
    this.props.onCategoryChange(e);
  };
  categoryEnterKeyEventHandler = (e) => {
    this.props.categoryEnterKeyEventHandler(e);
  };
  displayAutoCompleteCategoryList = (e) => {
    this.props.displayAutoCompleteCategoryList(e);
  };
  onVendorTermChange = (e) => {
    this.props.onVendorTermChange(e);
  };
  vendorTermEnterKeyEventHandler = (e) => {
    this.props.vendorTermEnterKeyEventHandler(e);
  };
  displayAutoCompleteBuyingTermsList = (e) => {
    this.props.displayAutoCompleteBuyingTermsList(e);
  };
  onShipmentTermChange = (e) => {
    this.props.onShipmentTermChange(e);
  };
  shipmentTermEnterKeyEventHandler = (e) => {
    this.props.shipmentTermEnterKeyEventHandler(e);
  };
  onFOBChange = (e) => {
    this.props.onFOBChange(e);
  };
  fobEnterKeyEventHandler = (e) => {
    this.props.fobEnterKeyEventHandler(e);
  };
  displayAutoCompleteShipmentTermList = (showAutoCompleteList) => {
    this.props.displayAutoCompleteShipmentTermList(showAutoCompleteList);
  };
  onIncoTermChange = (e) => {
    this.props.onIncoTermChange(e);
  };
  incoTermEnterKeyEventHandler = (e) => {
    this.props.incoTermEnterKeyEventHandler(e);
  };
  displayAutoCompleteIncoTermList = (showAutoCompleteList) => {
    this.props.displayAutoCompleteIncoTermList(showAutoCompleteList);
  };
  displayAutoCompleteFobList = (showAutoCompleteList) => {
    this.props.displayAutoCompleteFobList(showAutoCompleteList);
  };
  saveVendor = (e) => {
    this.props.saveVendor(this.props.vendorData, this.props.addressData);
  };
  closeEntryForm() {
    this.props.closeEntryForm();
  }
  showVendorList = () => {
    this.props.showVendorList();
  };
  openVendorOnOrderInq = (e, code) => {
    if (e.detail == 1) this.props.openVendorOnOrderInq(code);
  };
  openVendorPurchaseHistoryInq = (e, code) => {
    if (e.detail == 1) this.props.openVendorPurchaseHistoryInq(code);
  };
  closeModalCallBack = (isOpen) => {
    this.props.closeModalCallBack(isOpen);
  };
  handleChange = (e) => {
    let temp_vendorData = this.state.vendorData;
    temp_vendorData[e.target.name] = e.target.value;
    this.setState({ vendorData: temp_vendorData });
  };
  render() {
    let vendorData = this.props.vendorData;
    console.log("vendorData",vendorData);
    
    let addressData = this.props.addressData;
    let wareHouses = this.props.wareHouses;
    let currencies = this.props.currencies;
    let fOBCities = this.props.fOBCities;
    let shipmentTerms = this.props.shipmentTerms;
    let incoTerms = this.props.incoTerms;
    let paymentTerms = this.props.paymentTerms;
    let vendorTerms = this.props.vendorTerms;
    let transportTypes = this.props.transportTypes;
    let countries = this.props.countries;
    let isDisabledFields = this.props.isDisabledFields;

    const textAreaStyle = {
      height: "3em",
      width: "25em",
      resize: "none",
      padding: "2px",
      boxSizing: "border-box",
      fontSize: "15px",
    };

    return (
      <div>
        <MultiViewPopup
          popupLvlClass={"popupSizeLevel1"}
          isModulePopup={true}
          id="modulePopup"
          isShowPopup={this.props.isShowVendorOnOrderInq}
          closeModalCallBack={this.closeModalCallBack}
          module={this.props.moduleForPopup}
        ></MultiViewPopup>
        <MultiViewPopup
          popupLvlClass={"popupSizeLevel1"}
          isModulePopup={true}
          id="modulePopup"
          isShowPopup={this.props.isShowVendorPurchaseHistoryInq}
          closeModalCallBack={this.closeModalCallBack}
          module={this.props.moduleForPopup}
        ></MultiViewPopup>
        <div className="header_div">
          <Row>
            <Col className="so-align-items-left" sm="1">
              <FormLabel>Vendor</FormLabel>
              <Col>
                {vendorData.isFetched != false &&
                  vendorData.code != "" &&
                  vendorData.code != NEW_ENTRY &&
                  vendorData.code != undefined ? (
                  <ShortCutMenuPopup
                    value={vendorData.code}
                    menuItems={
                      <ul>
                        <li
                          className="shortcut-menu-item"
                          onClick={(e) =>
                            this.openVendorOnOrderInq(e, vendorData.code)
                          }
                        >
                          {" "}
                          Vendor OnOrder{" "}
                        </li>
                        <li
                          className="shortcut-menu-item"
                          onClick={(e) =>
                            this.openVendorPurchaseHistoryInq(
                              e,
                              vendorData.code
                            )
                          }
                        >
                          {" "}
                          Vendor Purchase History{" "}
                        </li>
                      </ul>
                    }
                  />
                ) : null}
              </Col>
            </Col>
            <Col sm="2">
              <InputTextbox
                onChange={this.onChange}
                name="code"
                value={vendorData.code}
                disabled={true}
              ></InputTextbox>
            </Col>
            <Col sm="1">
              <FormLabel>VendorName</FormLabel>{" "}
            </Col>
            <Col sm="2">
              <InputTextbox
                ref={this.vendorNameRef}
                name="description"
                type="text"
                placeholder="Enter VendorShortName"
                onChange={this.onChange}
                value={vendorData.description}
                style={{ "text-transform": "uppercase" }}
                disabled={isDisabledFields}
                isMandatory={true}
              />{" "}
            </Col>
            <Col sm="1">
              <FormLabel>Active</FormLabel>{" "}
            </Col>
            <Col sm="1">
              <InputCheckbox
                name="isActive"
                type="checkbox"
                checked={vendorData.isActive}
                onChange={this.onChange}
                disabled={isDisabledFields}
              />
            </Col>
            <Col sm="1">
              {" "}
              <FormLabel>Contractor</FormLabel>{" "}
            </Col>{" "}
            <Col sm="1">
              <InputCheckbox
                name="isContractor"
                type="checkbox"
                checked={vendorData.isContractor}
                onChange={this.onChange}
                disabled={isDisabledFields}
              />
            </Col>{" "}
            <Col sm="1">
              {" "}
              <FormLabel>TicketVendor</FormLabel>{" "}
            </Col>{" "}
            <Col sm="1">
              <InputCheckbox
                name="isTicketVendor"
                type="checkbox"
                checked={vendorData.isTicketVendor}
                onChange={this.onChange}
                disabled={isDisabledFields}
              />
            </Col>{" "}
          </Row>
          <Row>
            <Col sm="1">
              {" "}
              <FormLabel>LegalName</FormLabel>{" "}
            </Col>
            <Col sm="2">
              <InputTextbox
                name="legalName"
                type="text"
                placeholder="Enter legalName"
                onChange={this.onChange}
                value={vendorData.legalName}
                disabled={isDisabledFields}
              />{" "}
            </Col>
            <Col sm="1">
              {" "}
              <FormLabel>WareHouse</FormLabel>{" "}
            </Col>
            <Col sm="2">
              <InputTextbox
                onChange={this.onLocationChange}
                ref={this.warehouseRef}
                name="locationCode"
                placeholder="locationCode"
                value={vendorData.locationCode}
                lookupRequired={true}
                lookupHandler={this.state.warehouseLookupHandler}
                enterKeyEventHandler={this.locationEnterKeyEventHandler}
                autoCompleteListData={
                  this.props.locationPageListForAutoCompleteList
                }
                enableAutoCompleteTextBox={true}
                displayAutoCompleteList={this.displayAutoCompleteLocationList}
                showAutoCompleteList={this.props.showAutoCompleteLocationList}
                disabled={isDisabledFields}
              ></InputTextbox>
            </Col>
            <Col sm="1">
              {" "}
              <FormLabel>Discount%</FormLabel>{" "}
            </Col>
            <Col sm="2">
              {" "}
              <NumberFormatInputbox
                name={"buyingDiscount"}
                onChange={this.onChange}
                placeholder="Enter Discount"
                value={vendorData.buyingDiscount}
                className="text-right"
                decimalScale={2}
                disabled={isDisabledFields}
              />
            </Col>
            <Col sm="1">
              {" "}
              <FormLabel>Category</FormLabel>{" "}
            </Col>
            <Col sm="2">
              {" "}
              <InputTextbox
                onChange={this.onCategoryChange}
                ref={this.categoryRef}
                name="vendorCategoryCode"
                placeholder="vendorCategoryCode"
                value={vendorData.vendorCategoryCode}
                lookupRequired={true}
                lookupHandler={this.state.categoryLookupHandler}
                enterKeyEventHandler={this.categoryEnterKeyEventHandler}
                autoCompleteListData={
                  this.props.categoryPageListForAutoCompleteList
                }
                enableAutoCompleteTextBox={true}
                displayAutoCompleteList={this.displayAutoCompleteCategoryList}
                showAutoCompleteList={this.props.showAutoCompleteCategoryList}
                disabled={isDisabledFields}
              ></InputTextbox>
            </Col>
          </Row>
          <Row>
            <Col sm="1">
              {" "}
              <FormLabel>BuyingTerms</FormLabel>{" "}
            </Col>
            <Col sm="2">
              <InputTextbox
                onChange={this.onVendorTermChange}
                ref={this.vendorTermRef}
                name="buyingTermsCode"
                placeholder="buyingTermsCode"
                value={vendorData.buyingTermsCode}
                lookupRequired={true}
                lookupHandler={this.state.vendorTermLookupHandler}
                enterKeyEventHandler={this.vendorTermEnterKeyEventHandler}
                autoCompleteListData={
                  this.props.vendorTermPageListForAutoCompleteList
                }
                enableAutoCompleteTextBox={true}
                displayAutoCompleteList={
                  this.displayAutoCompleteBuyingTermsList
                }
                showAutoCompleteList={this.props.showAutoCompleteVendorTermList}
                disabled={isDisabledFields}
              ></InputTextbox>
            </Col>
            <Col sm="1">
              <FormLabel>Currency </FormLabel>{" "}
            </Col>
            <Col sm="2">
              <InputTextbox
                onChange={this.onCurrencyCodeChange}
                ref={this.currencyRef}
                name="currencyCode"
                placeholder="currencyCode"
                value={vendorData.currencyCode}
                lookupRequired={true}
                lookupHandler={this.state.currencyLookupHandler}
                enterKeyEventHandler={this.currencyCodeEnterKeyEvent}
                autoCompleteListData={
                  this.props.currencyCodePageListForAutoCompleteList
                }
                enableAutoCompleteTextBox={true}
                displayAutoCompleteList={this.displayAutoCompleteCurrencyList}
                showAutoCompleteList={
                  this.props.showAutoCompleteCurrencyCodeList
                }
                disabled={isDisabledFields}
              ></InputTextbox>
            </Col>
            <Col sm="1">
              {" "}
              <FormLabel>ShipVia</FormLabel>{" "}
            </Col>
            <Col sm="2">
              <InputTextbox
                onChange={this.onShipViaChange}
                ref={this.shipViaRef}
                name="shipViaCode"
                placeholder="shipViaCode"
                value={vendorData.shipViaCode}
                lookupRequired={true}
                lookupHandler={this.state.shipViaLookupHandler}
                enterKeyEventHandler={this.shipViaEnterKeyEvent}
                autoCompleteListData={
                  this.props.shipViaPageListForAutoCompleteList
                }
                enableAutoCompleteTextBox={true}
                displayAutoCompleteList={this.displayAutoCompleteShipViaList}
                showAutoCompleteList={this.props.showAutoCompleteShipViaList}
                disabled={isDisabledFields}
              />{" "}
            </Col>
            <Col sm="1">
              {" "}
              <FormLabel>ShippingTerms</FormLabel>{" "}
            </Col>
            <Col sm="2">
              <InputTextbox
                onChange={this.onShipmentTermChange}
                ref={this.shipmentTermRef}
                name="shipmentTermsCode"
                placeholder="shipmentTermsCode"
                value={vendorData.shipmentTermsCode}
                lookupRequired={true}
                lookupHandler={this.state.shipmentTermLookupHandler}
                enterKeyEventHandler={this.shipmentTermEnterKeyEventHandler}
                autoCompleteListData={
                  this.props.shipmentTermPageListForAutoCompleteList
                }
                enableAutoCompleteTextBox={true}
                displayAutoCompleteList={
                  this.displayAutoCompleteShipmentTermList
                }
                showAutoCompleteList={
                  this.props.showAutoCompleteShipmentTermList
                }
                disabled={isDisabledFields}
              ></InputTextbox>
            </Col>
          </Row>
          <Row>
            <Col sm="1">
              {" "}
              <FormLabel>VendorType</FormLabel>{" "}
            </Col>
            <Col sm="2">
              <InputTextbox
                onChange={this.onVendorTypeChange}
                ref={this.vendorTypeRef}
                name="vendorTypeCode"
                placeholder="vendorTypeCode"
                value={vendorData.vendorTypeCode}
                lookupRequired={true}
                lookupHandler={this.state.vendorTypeHandler}
                enterKeyEventHandler={this.vendorTypeEnterKeyEventHandler}
                autoCompleteListData={
                  this.props.vendorTypePageListForAutoCompleteList
                }
                enableAutoCompleteTextBox={true}
                displayAutoCompleteList={this.displayAutoCompleteVendorTypeList}
                showAutoCompleteList={this.props.showAutoCompleteVendorTypeList}
                disabled={isDisabledFields}
              ></InputTextbox>
            </Col>
            <Col sm="1">
              {" "}
              <FormLabel>FOBCity</FormLabel>{" "}
            </Col>
            <Col sm="2">
              <InputTextbox
                onChange={this.onFOBChange}
                ref={this.fobCityRef}
                name="fOBCity"
                placeholder="fOBCity"
                value={vendorData.fOBCity}
                lookupRequired={true}
                lookupHandler={this.state.fobCityLookupHandler}
                enterKeyEventHandler={this.fobEnterKeyEventHandler}
                autoCompleteListData={this.props.fobPageListForAutoCompleteList}
                enableAutoCompleteTextBox={true}
                displayAutoCompleteList={this.displayAutoCompleteFobList}
                showAutoCompleteList={this.props.showAutoCompleteFOBList}
                disabled={isDisabledFields}
              ></InputTextbox>
            </Col>
            <Col sm="1">
              {" "}
              <FormLabel>DaysToFF</FormLabel>{" "}
            </Col>
            <Col sm="2">
              {/* <InputTextbox
                name="daysToFrightForwarding"
                type="number"
                placeholder="Enter daysToFrightForwarding"
                onChange={this.onChange}
                value={vendorData.daysToFrightForwarding}
                disabled={isDisabledFields}
              />{" "}
               */}
              <NumberFormatInputbox
                name={"daysToFrightForwarding"}
                placeholder="Enter daysToFrightForwarding"
                value={vendorData.daysToFrightForwarding}
                onChange={this.onChange}
                className="text-right"
                disabled={isDisabledFields}
              />
            </Col>
            <Col sm="1">
              {" "}
              <FormLabel>Manufacturing CountryCode</FormLabel>{" "}
            </Col>
            <Col sm="2">
              <InputTextbox
                onChange={this.onCountryChange}
                ref={this.countryRef}
                name="manufacturingCountryCode"
                placeholder="manufacturingCountryCode"
                value={vendorData.manufacturingCountryCode}
                lookupRequired={true}
                lookupHandler={this.state.countryLookupHandler}
                enterKeyEventHandler={this.countryEnterKeyEvent}
                autoCompleteListData={
                  this.props.countryPageListForAutoCompleteList
                }
                enableAutoCompleteTextBox={true}
                displayAutoCompleteList={this.displayAutoCompleteCountryList}
                showAutoCompleteList={this.props.showAutoCompleteCountryList}
                disabled={isDisabledFields}
              ></InputTextbox>
            </Col>
          </Row>
          <Row>
            <Col sm="1">
              {" "}
              <FormLabel>Incoterm</FormLabel>{" "}
            </Col>
            <Col sm="2">
              <InputTextbox
                onChange={this.onIncoTermChange}
                ref={this.incoTermRef}
                name="incoterm"
                placeholder="incoterm"
                value={vendorData.incoterm}
                lookupRequired={true}
                lookupHandler={this.state.incoTermLookupHandler}
                enterKeyEventHandler={this.incoTermEnterKeyEventHandler}
                autoCompleteListData={
                  this.props.incoTermPageListForAutoCompleteList
                }
                enableAutoCompleteTextBox={true}
                displayAutoCompleteList={this.displayAutoCompleteIncoTermList}
                showAutoCompleteList={this.props.showAutoCompleteIncoTermList}
                disabled={isDisabledFields}
              ></InputTextbox>
            </Col>
            <Col sm="1">
              {" "}
              <FormLabel>LetterOfCreditTerms</FormLabel>{" "}
            </Col>
            <Col sm="2">
              <InputTextbox
                name="letterOfCreditTerms"
                type="text"
                placeholder="Enter letterOfCreditTerms"
                onChange={this.onChange}
                value={vendorData.letterOfCreditTerms}
                disabled={isDisabledFields}
              />{" "}
            </Col>
            <Col sm="1">
              {" "}
              <FormLabel>AccountNumber</FormLabel>{" "}
            </Col>
            <Col sm="2">
              <InputTextbox
                name="accountNumber"
                type="text"
                placeholder="Enter accountNumber"
                onChange={this.onChange}
                value={vendorData.accountNumber}
                disabled={isDisabledFields}
              />{" "}
            </Col>
            {/* <Col sm="1">
              {" "}
              <FormLabel>ShipServiceLevel</FormLabel>{" "}
            </Col>
            <Col sm="2">
              <InputTextbox
                name="shipServiceLevel"
                type="text"
                placeholder="Enter shipServiceLevel"
                onChange={this.onChange}
                value={vendorData.shipServiceLevel}
                disabled={isDisabledFields}
              />{" "}
            </Col> */}
            <Col sm="1">
              {" "}
              <FormLabel>TaxId</FormLabel>{" "}
            </Col>
            <Col sm="2">
              <InputTextbox
                name="taxId"
                type="text"
                placeholder="Enter taxId"
                onChange={this.onChange}
                value={vendorData.taxId}
                disabled={isDisabledFields}
              />{" "}
            </Col>
          </Row>
          <Row></Row>
          <Row>
            <Col sm="1">
              <FormLabel>Memo Text</FormLabel>
            </Col>
            <Col sm="3">
              <textarea
                style={textAreaStyle}
                className="form-control"
                type="text"
                name="memoText"
                value={vendorData.memoText}
                onChange={this.onChange}
                disabled={isDisabledFields}
              />
            </Col>
            <Col sm="1">
              <FormLabel>Comments</FormLabel>
            </Col>
            <Col sm="3">
              <textarea
                style={textAreaStyle}
                className="form-control"
                type="text"
                name="comments"
                value={vendorData.comments}
                onChange={this.onChange}
                disabled={isDisabledFields}
              />
            </Col>
          </Row>
        </div>
        <div className="header_div">
          <Row>
            <Col sm="1">
              {" "}
              <FormLabel>Address-1</FormLabel>{" "}
            </Col>
            <Col sm="2">
              {" "}
              <InputTextbox
                name="address1"
                type="text"
                placeholder="Enter Address"
                onChange={this.onChange}
                value={addressData.address1}
                disabled={isDisabledFields}
              />{" "}
            </Col>

            <Col sm="1">
              {" "}
              <FormLabel>Address-2</FormLabel>{" "}
            </Col>
            <Col sm="2">
              {" "}
              <InputTextbox
                name="address2"
                type="text"
                placeholder="Enter Address"
                onChange={this.onChange}
                value={addressData.address2}
                disabled={isDisabledFields}
              />{" "}
            </Col>
            <Col sm="1">
              {" "}
              <FormLabel>Address-3</FormLabel>{" "}
            </Col>
            <Col sm="2">
              {" "}
              <InputTextbox
                name="address3"
                type="text"
                placeholder="Enter Address"
                onChange={this.onChange}
                value={addressData.address3}
                disabled={isDisabledFields}
              />{" "}
            </Col>
            <Col sm="1">
              {" "}
              <FormLabel>Address-4</FormLabel>{" "}
            </Col>
            <Col sm="2">
              {" "}
              <InputTextbox
                name="address4"
                type="text"
                placeholder="Enter Address"
                onChange={this.onChange}
                value={addressData.address4}
                disabled={isDisabledFields}
              />{" "}
            </Col>
          </Row>
          <Row>
            <Col sm="1">
              {" "}
              <FormLabel>City</FormLabel>{" "}
            </Col>
            <Col sm="2">
              {" "}
              <InputTextbox
                ref={this.cityRef}
                name="city"
                type="text"
                placeholder="Enter City"
                onChange={this.onCityChange}
                value={addressData.city}
                lookupRequired={true}
                lookupHandler={this.state.cityLookupHandler}
                enterKeyEventHandler={this.cityEnterKeyEvent}
                autoCompleteListData={
                  this.props.cityPageListForAutoCompleteList
                }
                enableAutoCompleteTextBox={true}
                displayAutoCompleteList={this.displayAutoCompleteCityList}
                showAutoCompleteList={this.props.showAutoCompleteCityList}
                disabled={isDisabledFields}
              />{" "}
            </Col>
            <Col sm="1">
              {" "}
              <FormLabel>State</FormLabel>{" "}
            </Col>
            <Col sm="2">
              {" "}
              <InputTextbox
                ref={this.stateRef}
                name="state"
                type="text"
                placeholder="Enter State"
                onChange={this.onStateChange}
                value={addressData.state}
                lookupRequired={true}
                lookupHandler={this.state.stateLookupHandler}
                enterKeyEventHandler={this.stateEnterKeyEvent}
                autoCompleteListData={
                  this.props.statePageListForAutoCompleteList
                }
                enableAutoCompleteTextBox={true}
                displayAutoCompleteList={this.displayAutoCompleteStateList}
                showAutoCompleteList={this.props.showAutoCompleteStateList}
                disabled={isDisabledFields}
              />{" "}
            </Col>
            <Col sm="1">
              {" "}
              <FormLabel>Country</FormLabel>{" "}
            </Col>
            <Col sm="2">
              {" "}
              <InputTextbox
                ref={this.countryRef}
                name="country"
                type="text"
                placeholder="Enter Country"
                onChange={this.onCountryCodeChange}
                value={addressData.country}
                lookupRequired={true}
                lookupHandler={this.state.countryLookupHandler}
                enterKeyEventHandler={this.countryCodeEnterKeyEvent}
                autoCompleteListData={
                  this.props.countryCodePageListForAutoCompleteList
                }
                enableAutoCompleteTextBox={true}
                displayAutoCompleteList={
                  this.displayAutoCompleteCountryCodeList
                }
                showAutoCompleteList={
                  this.props.showAutoCompleteCountryCodeList
                }
                disabled={isDisabledFields}
              />{" "}
            </Col>
            <Col sm="1">
              {" "}
              <FormLabel>Zip</FormLabel>{" "}
            </Col>
            <Col sm="2">
              {" "}
              <InputTextbox
                name="zip"
                type="text"
                placeholder="Enter Zip"
                onChange={this.onChange}
                value={addressData.zip}
                disabled={isDisabledFields}
              />{" "}
            </Col>
          </Row>
          <Row>
            <Col sm="1">
              {" "}
              <FormLabel>ContactPerson</FormLabel>{" "}
            </Col>
            <Col sm="2">
              {" "}
              <InputTextbox
                name="contactPerson"
                type="text"
                placeholder="Enter ContactPerson"
                onChange={this.onChange}
                value={addressData.contactPerson}
                disabled={isDisabledFields}
              />{" "}
            </Col>
            <Col sm="1">
              {" "}
              <FormLabel>Mobile#</FormLabel>{" "}
            </Col>
            <Col sm="2">
              {" "}
              <InputTextbox
                name="mobilePhone"
                type="text"
                placeholder="Enter Mobile#"
                onChange={this.onChange}
                value={addressData.mobilePhone}
                disabled={isDisabledFields}
              />{" "}
            </Col>
            <Col sm="1">
              {" "}
              <FormLabel>Phone-1</FormLabel>{" "}
            </Col>
            <Col sm="2">
              {" "}
              <InputTextbox
                name="phone1"
                type="text"
                placeholder="Enter Phone#"
                onChange={this.onChange}
                value={addressData.phone1}
                disabled={isDisabledFields}
              />{" "}
            </Col>
            <Col sm="1">
              {" "}
              <FormLabel>Phone-2</FormLabel>{" "}
            </Col>
            <Col sm="2">
              {" "}
              <InputTextbox
                name="phone2"
                type="text"
                placeholder="Enter Phone#"
                onChange={this.onChange}
                value={addressData.phone2}
                disabled={isDisabledFields}
              />{" "}
            </Col>
          </Row>
          <Row>
            <Col sm="1">
              {" "}
              <FormLabel>Email</FormLabel>{" "}
            </Col>
            <Col sm="2">
              {" "}
              <InputTextbox
                name="email"
                type="text"
                placeholder="Enter Email"
                onChange={this.onChange}
                value={addressData.email}
                disabled={isDisabledFields}
              />{" "}
            </Col>
            <Col sm="1">
              {" "}
              <FormLabel>Website</FormLabel>{" "}
            </Col>
            <Col sm="2">
              {" "}
              <InputTextbox
                name="website"
                type="text"
                placeholder="Enter website"
                onChange={this.onChange}
                value={addressData.website}
                disabled={isDisabledFields}
              />{" "}
            </Col>
          </Row>
        </div>
      </div>
    );
  }
}
class VendorListForm extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      showHide: this.props.showHide,
      vendor_list: this.props.vendor_list,

      pageList: new PageListBean(),
      criteria: new VendorSearchCriteria(),
    };
  }
  componentDidMount() { }

  onChange = (e) => {
    let criteria = this.props.criteria;
    criteria["vendorNameContains"] = e.target.value;
    this.setState({ criteria: criteria });
  };
  editVendor = (e, val) => {
    if (e.detail == 1) this.props.editVendor(val, false);
  };
  filterVendors = (e) => {
    if (e.detail == 1) this.props.filterVendors();
  };
  resetfilterVendors = (e) => {
    if (e.detail == 1) this.props.resetfilterVendors();
  };
  loadFirst = (e) => {
    if (e.detail == 1) this.props.loadFirst();
  };
  loadNext = (e) => {
    if (e.detail == 1) this.props.loadNext();
  };
  loadPrevious = (e) => {
    if (e.detail == 1) this.props.loadPrevious();
  };
  loadLast = (e) => {
    if (e.detail == 1) this.props.loadLast();
  };
  handleSortingChange = (e, accessor) => {
    if (e.detail == 1) this.props.handleSortingChange(accessor);
  };
  onKeyDown = (e) => {
    if (e.keyCode == 13) {
      this.props.filterVendors();
    }
  };
  render() {
    let vendor_list = new Array();
    if (!isEmptyArray(this.props.vendor_list)) {
      vendor_list = this.props.vendor_list;
    }
    // let vendor_list = null;
    let criteria = this.props.criteria;
    let pageList = this.props.pageList;

    let totalPages = 0;
    let pageSize = pageList.pageSize;
    let totalCount = pageList.totalCount;
    totalPages = totalCount / pageSize;
    totalPages += totalCount % pageSize == 0 ? 0 : 1;

    let isLoading = this.props.isLoading;
    return (
      <div>
        <div className="secondary_module_header">
          <div className="secondary_module_header_title">
            <FormLabel className="secondary_module_search_color">
              Search
            </FormLabel>
            <span className="secondary_module_header_title_2">
              <InputTextbox
                name="vendorNameContains"
                type="text"
                value={criteria.vendorNameContains}
                placeholder="Enter Value to Filter.."
                onChange={this.onChange}
                onKeyDown={this.onKeyDown}
              />
              <span className="px-2"></span>
              <Button onClick={(e) => this.filterVendors(e)}>Filter</Button>
              <span className="px-2"></span>
              <Button onClick={(e) => this.resetfilterVendors(e)}>Reset</Button>
            </span>
          </div>
          <div className="module_header_secondary_buttons">
            <Button
              size="sm"
              className="secondary_header_buttons"
              onClick={(e) => this.loadFirst(e)}
            >
              First
            </Button>
            <Button
              size="sm"
              className="secondary_header_buttons"
              onClick={(e) => this.loadPrevious(e)}
            >
              Previous
            </Button>
            <span>
              PAGE - {pageList.currentPage} OF {parseInt(totalPages)}
            </span>
            <Button
              size="sm"
              className="secondary_header_buttons"
              onClick={(e) => this.loadNext(e)}
            >
              Next
            </Button>
            <Button
              size="sm"
              className="secondary_header_buttons"
              onClick={(e) => this.loadLast(e)}
            >
              Last
            </Button>
          </div>
        </div>
        <div className="div_default">
          <Table id="fabrics_tables_default">
            <thead>
              <tr>
                <th onClick={(e) => this.handleSortingChange(e, "code")}>
                  VendorCode
                  {this.props.order === "desc" &&
                    this.props.sortField === "code" ? (
                    <span className="drp-dwn-cntr">
                      <DropDwnUp />
                    </span>
                  ) : (
                    <span className="drp-dwn-cntr">
                      <DropDwnDown />
                    </span>
                  )}
                </th>
                <th onClick={(e) => this.handleSortingChange(e, "description")}>
                  VendorName
                  {this.props.order === "desc" &&
                    this.props.sortField === "description" ? (
                    <span className="drp-dwn-cntr">
                      <DropDwnUp />
                    </span>
                  ) : (
                    <span className="drp-dwn-cntr">
                      <DropDwnDown />
                    </span>
                  )}
                </th>
                <th
                  onClick={(e) =>
                    this.handleSortingChange(e, "vendorCategoryCode")
                  }
                >
                  VendorCategory
                  {this.props.order === "desc" &&
                    this.props.sortField === "vendorCategoryCode" ? (
                    <span className="drp-dwn-cntr">
                      <DropDwnUp />
                    </span>
                  ) : (
                    <span className="drp-dwn-cntr">
                      <DropDwnDown />
                    </span>
                  )}
                </th>
                <th
                  onClick={(e) => this.handleSortingChange(e, "currencyCode")}
                >
                  Currency
                  {this.props.order === "desc" &&
                    this.props.sortField === "currencyCode" ? (
                    <span className="drp-dwn-cntr">
                      <DropDwnUp />
                    </span>
                  ) : (
                    <span className="drp-dwn-cntr">
                      <DropDwnDown />
                    </span>
                  )}
                </th>
                <th
                  onClick={(e) =>
                    this.handleSortingChange(e, "buyingTermsCode")
                  }
                >
                  BuyingTerms
                  {this.props.order === "desc" &&
                    this.props.sortField === "buyingTermsCode" ? (
                    <span className="drp-dwn-cntr">
                      <DropDwnUp />
                    </span>
                  ) : (
                    <span className="drp-dwn-cntr">
                      <DropDwnDown />
                    </span>
                  )}
                </th>
                <th
                  onClick={(e) =>
                    this.handleSortingChange(e, "shipmentTermsCode")
                  }
                >
                  ShipmentTerms
                  {this.props.order === "desc" &&
                    this.props.sortField === "shipmentTermsCode" ? (
                    <span className="drp-dwn-cntr">
                      <DropDwnUp />
                    </span>
                  ) : (
                    <span className="drp-dwn-cntr">
                      <DropDwnDown />
                    </span>
                  )}
                </th>
                {/* <th onClick={() => this.handleSortingChange("transportType")}>
                  TransportType
                  {this.props.order === "desc" &&
                  this.props.sortField === "transportType" ? (
                    <span className="drp-dwn-cntr">
                      <DropDwnUp />
                    </span>
                  ) : (
                    <span className="drp-dwn-cntr">
                      <DropDwnDown />
                    </span>
                  )}
                </th> */}
              </tr>
            </thead>
            {vendor_list != null ? (
              <tbody>
                {vendor_list.map((vendor, index) => (
                  <tr key={index}>
                    <td className="hyperLinkText">
                      <Button
                        variant="secondry"
                        className="hyperLinkText"
                        onClick={(e) => this.editVendor(e, vendor.code)}
                      >
                        {vendor.code}
                      </Button>
                    </td>
                    <td>{vendor.description}</td>
                    <td>{vendor.vendorCategoryCode}</td>
                    <td>{vendor.currencyCode}</td>
                    <td>{vendor.buyingTermsCode}</td>
                    <td>{vendor.shipmentTermsCode}</td>
                    {/* <td>{vendor.transportType}</td> */}
                  </tr>
                ))}
              </tbody>
            ) : null}
          </Table>
          {vendor_list != null ? null : (
            <div className="no_Data">{"NO DATA"}</div>
          )}
        </div>
      </div>
    );
  }
}
class VendorFactoryEntryForm extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      showHide: this.props.showHide,
      vendorFactoryData: this.props.currentVendorFactory,
      vendorFactoryAddressData: this.props.vendorFactoryAddressData,
      warehouses: this.props.warehouses,
    };
    this.fobCityRef = React.createRef();
    this.shipmentTermRef = React.createRef();
    this.shipViaRef = React.createRef();
    this.vendorTermRef = React.createRef();
    this.currencyRef = React.createRef();
    this.manufactureCountryRef = React.creat;
    this.stateRef = React.createRef();
    this.cityRef = React.createRef();
    this.countryRef = React.createRef();
  }
  componentDidMount() {
    this.initLookupHandlers();
  }
  initLookupHandlers = () => {
    let shipmentTermLookupHandler = new GenericAttributeLookupHandler(
      this.props.shipmentTerms,
      "ShipmentTerms"
    );
    this.setState({ shipmentTermLookupHandler: shipmentTermLookupHandler });

    let fobCityLookupHandler = new GenericAttributeLookupHandler(
      this.props.fOBCities,
      "FobCity"
    );
    this.setState({ fobCityLookupHandler: fobCityLookupHandler });

    let shipViaLookupHandler = new GenericAttributeLookupHandler(
      this.props.shipVias,
      "ShipVia"
    );
    this.setState({ shipViaLookupHandler: shipViaLookupHandler });
    let manufactureCountryLookupHandler = new GenericAttributeLookupHandler(
      this.props.countries,
      "Country"
    );
    this.setState({
      manufactureCountryLookupHandler: manufactureCountryLookupHandler,
    });
    let cityLookupHandler = new GenericAttributeLookupHandler(
      this.props.cities,
      "City"
    );
    this.setState({ cityLookupHandler: cityLookupHandler });

    let stateLookupHandler = new GenericAttributeLookupHandler(
      this.props.states,
      "State"
    );
    this.setState({ stateLookupHandler: stateLookupHandler });
    let countryLookupHandler = new GenericAttributeLookupHandler(
      this.props.countries,
      "Country"
    );
    this.setState({ countryLookupHandler: countryLookupHandler });
    let vendorTermLookupHandler = new GenericAttributeLookupHandler(
      this.props.vendorTerms,
      "VendorTerm"
    );
    this.setState({ vendorTermLookupHandler: vendorTermLookupHandler });
    let currencyLookupHandler = new GenericAttributeLookupHandler(
      this.props.currencies,
      "Currency"
    );
    this.setState({ currencyLookupHandler: currencyLookupHandler });
  };
  componentDidUpdate() {
    //
  }
  onChange = (e) => {
    let temp_vendorFactoryData = this.props.vendorFactoryData;
    if (e.target.name == "code") {
      temp_vendorFactoryData["code"] = e.target.value.toUpperCase();
    } else {
      temp_vendorFactoryData[e.target.name] = e.target.value;
    }

    let temp_addressData = this.props.vendorFactoryAddressData;
    if (
      e.target.name == "address1" ||
      e.target.name == "address2" ||
      e.target.name == "city" ||
      e.target.name == "state" ||
      e.target.name == "country" ||
      e.target.name == "zip" ||
      e.target.name == "mobilePhone" ||
      e.target.name == "phone1" ||
      e.target.name == "phone2" ||
      e.target.name == "contactPerson" ||
      e.target.name == "fax" ||
      e.target.name == "email" ||
      e.target.name == "website"
    ) {
      temp_addressData[e.target.name] = e.target.value;
    }
    this.setState({
      vendorFactoryData: temp_vendorFactoryData,
      vendorFactoryAddressData: temp_addressData,
    });
  };
  onAddressChange = (e) => {
    let temp_addressData = this.props.vendorFactoryAddressData;

    temp_addressData[e.target.name] = e.target.value;

    this.setState({ addressData: temp_addressData });
  };
  saveVendorFactory = (e) => {
    this.props.saveVendorFactory(
      this.props.vendorFactoryData,
      this.props.vendorFactoryAddressData
    );
  };
  closeEntryForm() {
    this.props.closeEntryForm();
  }
  showVendorList = () => {
    this.props.showVendorList();
  };
  displayAutoCompleteBuyingTermsList = (e) => {
    this.props.displayAutoCompleteBuyingTermsList(e);
  };
  onShipmentTermFactoryChange = (e) => {
    this.props.onShipmentTermFactoryChange(e);
  };
  shipmentTermFactoryEnterKeyEventHandler = (e) => {
    this.props.shipmentTermFactoryEnterKeyEventHandler(e);
  };
  onFOBFactoryChange = (e) => {
    this.props.onFOBFactoryChange(e);
  };
  fobFactoryEnterKeyEventHandler = (e) => {
    this.props.fobFactoryEnterKeyEventHandler(e);
  };
  displayAutoCompleteShipmentTermList = (showAutoCompleteList) => {
    this.props.displayAutoCompleteShipmentTermList(showAutoCompleteList);
  };
  displayAutoCompleteFobList = (showAutoCompleteList) => {
    this.props.displayAutoCompleteFobList(showAutoCompleteList);
  };
  onCityFactoryChange = (e) => {
    this.props.onCityFactoryChange(e);
  };
  cityFactoryEnterKeyEvent = (e) => {
    this.props.cityFactoryEnterKeyEvent(e);
  };
  displayAutoCompleteCityList = (e) => {
    this.props.displayAutoCompleteCityList(e);
  };
  onStateFactoryChange = (e) => {
    this.props.onStateFactoryChange(e);
  };
  stateFactoryEnterKeyEvent = (e) => {
    this.props.stateFactoryEnterKeyEvent(e);
  };
  displayAutoCompleteStateList = (e) => {
    this.props.displayAutoCompleteStateList(e);
  };
  onCountryCodeFactoryChange = (e) => {
    this.props.onCountryCodeFactoryChange(e);
  };
  countryCodeFactoryEnterKeyEvent = (e) => {
    this.props.countryCodeFactoryEnterKeyEvent(e);
  };
  displayAutoCompleteCountryCodeList = (e) => {
    this.props.displayAutoCompleteCountryCodeList(e);
  };
  onCountryFactoryChange = (e) => {
    this.props.onCountryFactoryChange(e);
  };
  countryFactoryEnterKeyEvent = (e) => {
    this.props.countryFactoryEnterKeyEvent(e);
  };
  displayAutoCompleteCountryList = (e) => {
    this.props.displayAutoCompleteCountryList(e);
  };
  onCurrencyCodeFactoryChange = (e) => {
    this.props.onCurrencyCodeFactoryChange(e);
  };
  currencyCodeFactoryEnterKeyEvent = (e) => {
    this.props.currencyCodeFactoryEnterKeyEvent(e);
  };
  displayAutoCompleteCurrencyList = (e) => {
    this.props.displayAutoCompleteCurrencyList(e);
  };
  onShipViaFactoryChange = (e) => {
    this.props.onShipViaFactoryChange(e);
  };
  shipViaFactoryEnterKeyEvent = (e) => {
    this.props.shipViaFactoryEnterKeyEvent(e);
  };
  displayAutoCompleteShipViaList = (e) => {
    this.props.displayAutoCompleteShipViaList(e);
  };
  onVendorTermFactoryChange = (e) => {
    this.props.onVendorTermFactoryChange(e);
  };
  vendorTermFactoryEnterKeyEventHandler = (e) => {
    this.props.vendorTermFactoryEnterKeyEventHandler(e);
  };
  handleChange = (e) => {
    let temp_vendorFactoryData = this.props.vendorFactoryData;
    temp_vendorFactoryData[e.target.name] = e.target.value;
    this.setState({ vendorFactoryData: temp_vendorFactoryData });
  };
  backToFactoryList = (e) => {
    if (e.detail <= 1) this.props.backToFactoryList();
  };
  render() {
    let vendorFactoryData = this.props.vendorFactoryData;
    let addressData = this.props.vendorFactoryAddressData;
    let warehouses = this.props.warehouses;
    let fobCities = this.props.fobCities;
    let shipmentTerms = this.props.shipmentTerms;

    if (addressData == null) addressData = new AddressBean();
    // let isDisabledFields = this.props.disableVendorFactoryFields;
    let isDisabledFields = this.props.isDisabledFields;
    return (
      <div className="header_div">
        <Row>
          <Col sm="1">
            <FormLabel>Factory</FormLabel>{" "}
          </Col>
          <Col sm="2">
            <InputTextbox
              name="code"
              type="text"
              placeholder="Enter Factory Code"
              onChange={this.onChange}
              value={vendorFactoryData.code}
              style={{ "text-transform": "uppercase" }}
              disabled={isDisabledFields}
            />{" "}
          </Col>
          <Col sm="1">
            <FormLabel>Factory Name </FormLabel>{" "}
          </Col>

          <Col sm="2">
            <InputTextbox
              name="description"
              type="text"
              placeholder="Enter Factory Name"
              onChange={this.onChange}
              value={vendorFactoryData.description}
              disabled={isDisabledFields}
            />{" "}
          </Col>

          <Col sm="1">
            <FormLabel>Status </FormLabel>{" "}
          </Col>
          <Col sm="2">
            <InputTextbox
              name="status"
              type="text"
              placeholder=""
              onChange={this.onChange}
              value={vendorFactoryData.status}
              disabled={true}
            />{" "}
          </Col>
          <Col sm="1">
            <FormLabel>Buying Terms</FormLabel>{" "}
          </Col>
          <Col sm="2">
            <InputTextbox
              onChange={this.onVendorTermFactoryChange}
              ref={this.vendorTermRef}
              name="buyingTermsCode"
              placeholder="buyingTermsCode"
              value={vendorFactoryData.buyingTermsCode}
              lookupRequired={true}
              lookupHandler={this.state.vendorTermLookupHandler}
              enterKeyEventHandler={this.vendorTermFactoryEnterKeyEventHandler}
              autoCompleteListData={
                this.props.vendorTermPageListForAutoCompleteList
              }
              enableAutoCompleteTextBox={true}
              displayAutoCompleteList={this.displayAutoCompleteBuyingTermsList}
              showAutoCompleteList={this.props.showAutoCompleteVendorTermList}
              disabled={isDisabledFields}
            />{" "}
          </Col>
        </Row>
        <Row>
          <Col sm="1">
            <FormLabel>Currency</FormLabel>{" "}
          </Col>
          <Col sm="2">
            <InputTextbox
              onChange={this.onCurrencyCodeFactoryChange}
              ref={this.currencyRef}
              name="currencyCode"
              placeholder="currencyCode"
              value={vendorFactoryData.currencyCode}
              lookupRequired={true}
              lookupHandler={this.state.currencyLookupHandler}
              enterKeyEventHandler={this.currencyCodeFactoryEnterKeyEvent}
              autoCompleteListData={
                this.props.currencyCodePageListForAutoCompleteList
              }
              enableAutoCompleteTextBox={true}
              displayAutoCompleteList={this.displayAutoCompleteCurrencyList}
              showAutoCompleteList={this.props.showAutoCompleteCurrencyCodeList}
              disabled={isDisabledFields}
            />
          </Col>
          <Col sm="1">
            {" "}
            <FormLabel>FOB City</FormLabel>{" "}
          </Col>
          <Col sm="2">
            <InputTextbox
              onChange={this.onFOBFactoryChange}
              ref={this.fobCityRef}
              name="fOBCity"
              placeholder="fOBCity"
              value={vendorFactoryData.fOBCity}
              lookupRequired={true}
              lookupHandler={this.state.fobCityLookupHandler}
              enterKeyEventHandler={this.fobFactoryEnterKeyEventHandler}
              autoCompleteListData={this.props.fobPageListForAutoCompleteList}
              enableAutoCompleteTextBox={true}
              displayAutoCompleteList={this.displayAutoCompleteFobList}
              showAutoCompleteList={this.props.showAutoCompleteFOBList}
              disabled={isDisabledFields}
            ></InputTextbox>
          </Col>
          <Col sm="1">
            {" "}
            <FormLabel>Shipment Terms</FormLabel>{" "}
          </Col>
          <Col sm="2">
            {" "}
            <InputTextbox
              onChange={this.onShipmentTermFactoryChange}
              ref={this.shipmentTermRef}
              name="shipmentTermsCode"
              placeholder="shipmentTermsCode"
              value={vendorFactoryData.shipmentTermsCode}
              lookupRequired={true}
              lookupHandler={this.state.shipmentTermLookupHandler}
              enterKeyEventHandler={
                this.shipmentTermFactoryEnterKeyEventHandler
              }
              autoCompleteListData={
                this.props.shipmentTermPageListForAutoCompleteList
              }
              enableAutoCompleteTextBox={true}
              displayAutoCompleteList={this.displayAutoCompleteShipmentTermList}
              showAutoCompleteList={this.props.showAutoCompleteShipmentTermList}
              disabled={isDisabledFields}
            ></InputTextbox>
          </Col>
          <Col sm="1">
            {" "}
            <FormLabel>Ship Via</FormLabel>{" "}
          </Col>
          <Col sm="2">
            {" "}
            <InputTextbox
              onChange={this.onShipViaFactoryChange}
              ref={this.shipViaRef}
              name="shipViaCode"
              placeholder="shipViaCode"
              value={vendorFactoryData.shipViaCode}
              lookupRequired={true}
              lookupHandler={this.state.shipViaLookupHandler}
              enterKeyEventHandler={this.shipViaFactoryEnterKeyEvent}
              autoCompleteListData={
                this.props.shipViaPageListForAutoCompleteList
              }
              enableAutoCompleteTextBox={true}
              displayAutoCompleteList={this.displayAutoCompleteShipViaList}
              showAutoCompleteList={this.props.showAutoCompleteShipViaList}
              disabled={isDisabledFields}
            />{" "}
          </Col>
        </Row>
        <Row>
          <Col sm="1">
            {" "}
            <FormLabel>Manufacture Country</FormLabel>{" "}
          </Col>
          <Col sm="2">
            {" "}
            <InputTextbox
              onChange={this.onCountryFactoryChange}
              ref={this.manufactureCountryRef}
              name="manufacturingCountryCode"
              placeholder="manufacturingCountryCode"
              value={vendorFactoryData.manufacturingCountryCode}
              lookupRequired={true}
              lookupHandler={this.state.manufactureCountryLookupHandler}
              enterKeyEventHandler={this.countryFactoryEnterKeyEvent}
              autoCompleteListData={
                this.props.countryPageListForAutoCompleteList
              }
              enableAutoCompleteTextBox={true}
              displayAutoCompleteList={this.displayAutoCompleteCountryList}
              showAutoCompleteList={this.props.showAutoCompleteCountryList}
              disabled={isDisabledFields}
            />{" "}
          </Col>
          <Col sm="1">
            {" "}
            <FormLabel>Days to FF</FormLabel>{" "}
          </Col>
          <Col sm="2">
            {" "}
            <NumberFormatInputbox
              name={"daysToFrightForwarding"}
              placeholder="Enter daysToFrightForwarding"
              value={vendorFactoryData.daysToFrightForwarding}
              onChange={this.onChange}
              className="text-right"
              disabled={isDisabledFields}
            />
          </Col>
          <Col sm="1">
            {" "}
            <FormLabel>Comments</FormLabel>{" "}
          </Col>
          <Col sm="2">
            {" "}
            <InputTextbox
              name="comments"
              type="text"
              placeholder="Enter Comments"
              onChange={this.onChange}
              value={vendorFactoryData.comments}
              disabled={isDisabledFields}
            />{" "}
          </Col>
        </Row>
        <div>
          <Row>
            <Col sm="2">
              {" "}
              <FormLabel>Address Details </FormLabel>{" "}
            </Col>
          </Row>

          <Row>
            <Col sm="1">
              {" "}
              <FormLabel>Address-1 </FormLabel>{" "}
            </Col>
            <Col sm="2">
              {" "}
              <InputTextbox
                name="address1"
                type="text"
                placeholder="Enter Address"
                onChange={this.onAddressChange}
                value={addressData.address1}
                disabled={isDisabledFields}
              />{" "}
            </Col>
            <Col sm="1">
              {" "}
              <FormLabel>Address-2 </FormLabel>{" "}
            </Col>
            <Col sm="2">
              {" "}
              <InputTextbox
                name="address2"
                type="text"
                placeholder="Enter Address2"
                onChange={this.onAddressChange}
                value={addressData.address2}
              // disabled={isDisabledFields}
              />{" "}
            </Col>
            <Col sm="1">
              {" "}
              <FormLabel>Address-3 </FormLabel>{" "}
            </Col>
            <Col sm="2">
              {" "}
              <InputTextbox
                name="address3"
                type="text"
                placeholder="Enter Address3"
                onChange={this.onAddressChange}
                value={addressData.address3}
                disabled={isDisabledFields}
              />{" "}
            </Col>
            <Col sm="1">
              {" "}
              <FormLabel>Address-4 </FormLabel>{" "}
            </Col>
            <Col sm="2">
              {" "}
              <InputTextbox
                name="address4"
                type="text"
                placeholder="Enter Address4"
                onChange={this.onAddressChange}
                value={addressData.address4}
                disabled={isDisabledFields}
              />{" "}
            </Col>
          </Row>
          <Row>
            <Col sm="1">
              {" "}
              <FormLabel>City </FormLabel>{" "}
            </Col>
            <Col sm="2">
              {" "}
              <InputTextbox
                onChange={this.onCityFactoryChange}
                name="city"
                ref={this.cityRef}
                placeholder="city"
                value={addressData.city}
                lookupRequired={true}
                lookupHandler={this.state.cityLookupHandler}
                enterKeyEventHandler={this.cityFactoryEnterKeyEvent}
                autoCompleteListData={
                  this.props.cityPageListForAutoCompleteList
                }
                enableAutoCompleteTextBox={true}
                displayAutoCompleteList={this.displayAutoCompleteCityList}
                showAutoCompleteList={this.props.showAutoCompleteCityList}
                disabled={isDisabledFields}
              />{" "}
            </Col>
            <Col sm="1">
              {" "}
              <FormLabel>State </FormLabel>{" "}
            </Col>
            <Col sm="2">
              {" "}
              <InputTextbox
                onChange={this.onStateFactoryChange}
                ref={this.stateRef}
                name="state"
                placeholder="state"
                value={addressData.state}
                lookupRequired={true}
                lookupHandler={this.state.stateLookupHandler}
                enterKeyEventHandler={this.stateFactoryEnterKeyEvent}
                autoCompleteListData={
                  this.props.statePageListForAutoCompleteList
                }
                enableAutoCompleteTextBox={true}
                displayAutoCompleteList={this.displayAutoCompleteStateList}
                showAutoCompleteList={this.props.showAutoCompleteStateList}
                disabled={isDisabledFields}
              />{" "}
            </Col>
            <Col sm="1">
              {" "}
              <FormLabel>Country </FormLabel>{" "}
            </Col>
            <Col sm="2">
              {" "}
              <InputTextbox
                onChange={this.onCountryCodeFactoryChange}
                ref={this.countryRef}
                name="country"
                placeholder="country"
                value={addressData.country}
                lookupRequired={true}
                lookupHandler={this.state.countryLookupHandler}
                enterKeyEventHandler={this.countryCodeFactoryEnterKeyEvent}
                autoCompleteListData={
                  this.props.countryCodePageListForAutoCompleteList
                }
                enableAutoCompleteTextBox={true}
                displayAutoCompleteList={
                  this.displayAutoCompleteCountryCodeList
                }
                showAutoCompleteList={
                  this.props.showAutoCompleteCountryCodeList
                }
                disabled={isDisabledFields}
              />{" "}
            </Col>
            <Col sm="1">
              {" "}
              <FormLabel>Zip</FormLabel>{" "}
            </Col>
            <Col sm="2">
              {" "}
              <InputTextbox
                name="zip"
                type="text"
                placeholder="Enter zip"
                onChange={this.onAddressChange}
                value={addressData.zip}
                disabled={isDisabledFields}
              />{" "}
            </Col>
          </Row>
          <Row>
            <Col sm="1">
              {" "}
              <FormLabel>Email</FormLabel>{" "}
            </Col>
            <Col sm="2">
              {" "}
              <InputTextbox
                name="email"
                type="text"
                placeholder="Enter Email"
                onChange={this.onAddressChange}
                value={addressData.email}
                disabled={isDisabledFields}
              />{" "}
            </Col>
            <Col sm="1">
              {" "}
              <FormLabel>Contact Person</FormLabel>{" "}
            </Col>
            <Col sm="2">
              {" "}
              <InputTextbox
                name="contactPerson"
                type="text"
                placeholder="Enter ContactPerson"
                onChange={this.onAddressChange}
                value={addressData.contactPerson}
                disabled={isDisabledFields}
              />{" "}
            </Col>
            <Col sm="1">
              {" "}
              <FormLabel>Mobile Phone</FormLabel>{" "}
            </Col>
            <Col sm="2">
              {" "}
              <InputTextbox
                name="mobilePhone"
                type="text"
                placeholder="Enter Mobile Phone"
                onChange={this.onAddressChange}
                value={addressData.mobilePhone}
              // disabled={isDisabledFields}
              />{" "}
            </Col>
            <Col sm="1">
              {" "}
              <FormLabel>Phone</FormLabel>{" "}
            </Col>
            <Col sm="2">
              {" "}
              <InputTextbox
                name="phone1"
                type="text"
                placeholder="Enter Phone"
                onChange={this.onAddressChange}
                value={addressData.phone1}
                disabled={isDisabledFields}
              />{" "}
            </Col>
          </Row>
          <Row>
            <Col>
              <Button
                id="fabric_Add_Button"
                className="enterFocus"
                size="sm1"
                bssize="large"
                onClick={(e) => this.backToFactoryList(e)}
              >
                Back
              </Button>
            </Col>
          </Row>
        </div>
      </div>
    );
  }
}
class VendorFactoryListForm extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      showHide: this.props.showHide,
      vendorFactoryList: this.props.vendorFactoryList,
      vendorData: this.props.vendorData,
      vendorCode: this.props.vendorData.code,
      pageList: new PageListBean(),
      criteria: new VendorSearchCriteria(),
    };
  }
  componentDidMount() {
    this.filterVendorFactory(this.state.vendorCode);
  }
  componentDidUpdate() {
    //
  }
  onChange = (e) => {
    let criteria = this.props.criteria;
    if (e.target.name == "criteriakey") {
      criteria["vendorNameContains"] = e.target.value;
      criteria["vendorCodeContains"] = e.target.value;
      criteria["vendorCodeStartsWith"] = e.target.value;
    }
    this.setState({ criteria: criteria });
  };
  editVendorFactory = (e, vendorFactoryCode) => {
    if (e.detail == 1) this.props.editVendorFactory(vendorFactoryCode);
  };
  filterVendorFactory = (vendorCode) => {
    this.props.filterVendorFactory(vendorCode);
  };
  loadFirst = () => {
    this.props.loadFirst();
  };
  loadNext = () => {
    this.props.loadNext();
  };
  loadPrevious = () => {
    this.props.loadPrevious();
  };
  loadLast = () => {
    this.props.loadLast();
  };

  render() {
    let vendorFactoryList = this.props.vendorFactoryList;
    return (
      <div className="header_div">
        <div className="div_Custom_1">
          <Table id="fabrics_tables_default">
            <thead>
              <tr>
                <th>Factory Code</th>
                <th>Factory Name</th>
              </tr>
            </thead>
            <tbody>
              {vendorFactoryList.map((vendorFactory, index) => (
                <tr key={index}>
                  <td>
                    <Button
                      variant="secondry"
                      className="hyperLinkText"
                      onClick={(e) =>
                        this.editVendorFactory(e, vendorFactory.code)
                      }
                    >
                      {vendorFactory.code}
                    </Button>
                  </td>
                  <td>{vendorFactory.description}</td>
                </tr>
              ))}
            </tbody>
          </Table>
        </div>
      </div>
    );
  }
}
class VendorPurchaseDetails extends React.Component {
  static contextType = AppContext;
  constructor(props) {
    super(props);
    this.colorCodeRef = React.createRef();
    this.state = {
      vendorData: this.props.vendorData,
      criteria: new SalesAndPurchaseInquiryCriteriaBean(),
      error_list: [],
      inquiryDataList: [],
      isShowAlert: false,
      alertMessage: "",
      success_list: [],
      moduleForPopup: [],
      isShowProgressBarPopup: false,
      progressLoadingText: "",
      isShowFabricStyleModule: false,

      fabricLookupHandler: null,

      colorPageListForAutoCompleteList: new Array(),
      showAutoCompleteColorList: null,
      colorLookupHandler: null,
      colors: [],
      isShowPurchaseReceiptModule: false,
      isShowPurchaseModule:false,
      fabricPageListForAutoCompleteList:new Array(),
      showAutoCompleteFabricList:false,
    };
  }

  componentDidMount() {
    const { appData } = this.context;
    this.companyCode = appData.companyCode;
    const { cache } = appData;
    this.cache = cache;
    const attribute_cache = { ...cache };
    let colors = attribute_cache.colors;
    if (colors != null || colors != undefined) {
      colors.map((attr) => {
        this.state.colors.push(attr);
      });
    }

    this.initLookupHandlers();
  this.loadPage();
  }
  initLookupHandlers = () => {
    let colors = [];
    let fabricLookupHandler = new FabricStyleLookupHandler(
      this.companyCode,
      this.state.is3PL ? "Item" : "Fabric Style"
    );
    this.setState({ fabricLookupHandler: fabricLookupHandler });

    const customerLookupHandler = new CustomerLookupHandler(
      this.companyCode,
      "customerCode"
    );
    this.setState({
      customerLookupHandler: customerLookupHandler,
    });
    let colorLookupHandler = new GenericAttributeLookupHandler(
      this.state.colors,
      "fabricStyleColorCode"
    );
    this.setState({ colorLookupHandler: colorLookupHandler });
    // let vendorLookupHandler = new VendorLookupHandler(
    //   this.companyCode,
    //   "Vendor"
    // );
    // this.setState({ vendorLookupHandler: vendorLookupHandler });
  };
  readFabricStyleResponse = (response) => {
    let criteria = this.state.criteria;
    if (response.data != null && response.data.fabricStyle != null) {
      let fabricStyle = response.data.fabricStyle;
      criteria.fabricStylesCode = fabricStyle.code;
      this.setState({ fabricStyleData: fabricStyle });
    }
    this.setState({
      isShowProgressBarPopup: false,
      progressLoadingText: "",
    });
  };
  readFabricStyle = (fabricStyleCode) => {
    let input = new RestReadRequest();
    input.companyCode = this.companyCode;
    input.code = fabricStyleCode;
    input.isLoadChildren = true;
    FabricStyleService.readFabricStyle(
      input,
      this.readFabricStyleResponse,
      this.errorCallBack
    );
  };
  fabricCodeOnChange = (e) => {
    let fabricStyleCode = e.target.value;
    this.state.showAutoCompleteFabricList = true;
    let tempCriteria = this.state.criteria;
    let showAutoCompleteList = this.state.showAutoCompleteFabricList;
    if (isEmpty(fabricStyleCode)) {
      this.state.showAutoCompleteFabricList = false;
      let showAutoCompleteList = this.state.showAutoCompleteFabricList;
      let criteria = this.state.criteria;
      criteria.fabricStyleCode = "";
      criteria.fabricStyleName = "";
      let suggestion = [];
      this.setState({
        showAutoCompleteFabricList: showAutoCompleteList,
        criteria: criteria,
        fabricPageListForAutoCompleteList: suggestion,
        // isShowColorLookup: false,
        // colorList: [],
      });
    } else if (
      e.target.name == "fabricStyleCode" &&
      showAutoCompleteList === true &&
      fabricStyleCode !== ""
    ) {
      this.readFabricBySearchString(e.target.value);
    }
    tempCriteria[e.target.name] = e.target.value;
    this.setState({ criteria: tempCriteria });
  };
  readandsetFabricStyleDetailResponse = (response) => {
    let criteria = this.state.criteria;
    this.setState({
      isShowProgressBarPopup: false,
      progressLoadingText: "",
    });
    if (response.data != null && response.data.fabricStyle != null) {
      let fabricStyle = response.data.fabricStyle;
      if (!isEmpty(fabricStyle)) {
        criteria.fabricStyleCode = fabricStyle.code;
        criteria.fabricStyleName = fabricStyle.description;
        let colors = [];
        if (!isEmptyArray(fabricStyle.colors)) {
          colors = fabricStyle.colors;
        }
        let finalColorList = [];

        colors.map((ent) => {
          let colorBean = new BaseBean();
          colorBean.code = ent.fabricStyleColorCode;
          colorBean.description = ent.fabricStyleColorName;
          finalColorList.push(colorBean);
        });
        if (finalColorList != null) {
          let colorLookupHandler = new GenericAttributeLookupHandler(
            finalColorList,
            "Color"
          );
          this.setState({
            criteria: criteria,
            colorLookupHandler: colorLookupHandler,

          });
        }

      }
    }
  };
  readandsetFabricStyleDetail = (fabricStyleCode) => {
    let input = new RestReadRequest();
    input.companyCode = this.companyCode;
    input.code = fabricStyleCode;
    input.isLoadChildren = true;
    FabricStyleService.readFabricStyle(
      input,
      this.readandsetFabricStyleDetailResponse,
      this.errorCallBack
    );
  };
  readFabricBySearchString(searchString) {
    let searchCriteria = new FabricStyleSearchCriteria();
    searchCriteria.companyCode = this.companyCode;
    searchCriteria.fabricStyleCodeStartsWith = searchString;
    searchCriteria.fabricStyleNameStartsWith = searchString;
    let pageList = new RestPageListBean();
    pageList.pageSize = 100;
    let input = new RestFabricStyleListBeanRequest();
    input.companyCode = this.companyCode;
    input.pageInput = pageList;
    input.code = searchString;
    input.searchCriteria = searchCriteria;
    FabricStyleService.getActiveFabricStylesForAutoComplete(
      input,
      this.readByFabricCodeResponse,
      this.errorCallBack
    );
  }
  readByFabricCodeResponse = (response) => {
    let fabricStyleData = response.data.fabricStylePageList.fabricStyles;
    let simpleAutoCompleteList = new Array();
    if (fabricStyleData.length > 0 && fabricStyleData != null) {
      fabricStyleData.map((fabricStyle) => {
        let simpleItemBean = {
          code: fabricStyle.fabricStyleCode,
          description: fabricStyle.fabricStyleName,
        };
        simpleAutoCompleteList.push(simpleItemBean);
      });
    }
    this.setState({
      fabricPageListForAutoCompleteList: simpleAutoCompleteList,
    });
  };
  fabricEnterKeyEventHandler = (e) => {
    let fabricStyleCode = e.target.value;
    this.setState({
      isShowProgressBarPopup: true,
      progressLoadingText: this.state.is3PL ? "read Item" : "read Fabric",
    });
    this.readandsetFabricStyleDetail(fabricStyleCode);
    this.setState({ fabricPageListForAutoCompleteList: new Array() });
  };
  displayAutoCompleteFabricList = (showAutoCompleteFabricList) => {
    this.setState({ showAutoCompleteFabricList: showAutoCompleteFabricList });
  };
  onColorCodeChange = (e) => {
    let fabricStyleColorCode = e.target.value;
    this.state.showAutoCompleteColorList = true;
    let temp_fabricStyledata = this.state.criteria;
    let showAutoCompleteList = this.state.showAutoCompleteColorList;
    if (isEmpty(fabricStyleColorCode)) {
      this.state.showAutoCompleteColorList = false;
      let showAutoCompleteList = this.state.showAutoCompleteColorList;
      let color_Data = this.state.criteria;
      color_Data.fabricStyleColorCode = "";
      // color_Data.fabricStyleColorName = "";
      let suggestion = [];
      this.setState({
        showAutoCompleteColorList: showAutoCompleteList,
        criteria: color_Data,
        colorPageListForAutoCompleteList: suggestion,
      });
    } else if (showAutoCompleteList === true && fabricStyleColorCode !== "") {
      this.readColorCodeBySearchString(fabricStyleColorCode);
    }
    if (e.target.name == "fabricStyleColorCode") {
      temp_fabricStyledata["fabricStyleColorCode"] = e.target.value;
      let color_Data_List = this.state.colors;
      color_Data_List.map((color_Data) => {
        if (color_Data.code == e.target.value) {
          temp_fabricStyledata["fabricStyleColorCode"] = color_Data.code;
          this.state.showAutoCompleteColorList = false;
          let showAutoCompleteList = this.state.showAutoCompleteColorList;
          this.setState({
            showAutoCompleteColorList: showAutoCompleteList,
          });
        }
      });
    }
    this.setState({ criteria: temp_fabricStyledata });
  };
  readColorCodeBySearchString(searchString) {
    let colorCodeData = this.state.colors;
    let simpleAutoCompleteList = new Array();
    if (colorCodeData.length > 0 && colorCodeData != null) {
      colorCodeData.map((colorCodeDatas) => {
        let simpleItemBean = {
          code: colorCodeDatas.code,
          description: colorCodeDatas.description,
        };
        simpleAutoCompleteList.push(simpleItemBean);
      });
    }
    let userInput = searchString;
    let filteredSuggestions = new Array();
    filteredSuggestions = simpleAutoCompleteList.filter(
      (simpleAutoCompleteColorCodeLists) =>
        simpleAutoCompleteColorCodeLists.code
          .toLowerCase()
          .indexOf(userInput.toLowerCase()) > -1
    );
    this.setState({
      colorPageListForAutoCompleteList: filteredSuggestions,
    });
  }
  colorEnterKeyEvent = (e) => {
    let temp_fabricStyledata = this.state.criteria;
    let fabricStyleColorCode = e.target.value;
    temp_fabricStyledata["fabricStyleColorCode"] = e.target.value;
    let color_Data_List = this.state.colors;
    let colorCodeBean = null;
    color_Data_List.map((color_Data) => {
      if (color_Data.code == e.target.value) {
        colorCodeBean = color_Data;
      }
    });
    if (!isEmpty(colorCodeBean)) {
      let temp_fabricStyledata = this.state.criteria;
      temp_fabricStyledata.fabricStyleColorCode = colorCodeBean.code;
      // temp_fabricStyledata.fabricStyleColorName = colorCodeBean.description;
      this.setState({
        criteria: temp_fabricStyledata,
        colorPageListForAutoCompleteList: new Array(),
      });
    }
  };
  displayAutoCompleteColorList = (showAutoCompleteColorList) => {
    this.setState({
      showAutoCompleteColorList: showAutoCompleteColorList,
    });
  };
  onChange = (e) => {
    let criteria = this.state.criteria;
    criteria[e.target.name] = e.target.value;
    this.setState({ criteria: criteria });
  };
  loadPage = () => {
    let vendorData = this.state.vendorData;
    let criteria = this.state.criteria;
    criteria.companyCode = this.companyCode;
    criteria.vendorCode = vendorData.code;
    criteria.vendorName = vendorData.description;
    criteria.resultType = 1;
    // criteria.isSummary = true;
    // if (this.props.is3PL) {
    //   criteria.logisticCustomerCode = fabricStyleData.customerCode;
    // }
    this.loadSalesAndPurchaseDetailsInquiryList(criteria);
  };
  fetchPurchaseSales = () => {
    let criteria = this.state.criteria;
    let vendorData = this.state.vendorData;
    criteria.companyCode = this.companyCode;
    criteria.vendorCode = vendorData.code;
    criteria.vendorName = vendorData.description;
    criteria.resultType = 1;
    this.loadSalesAndPurchaseDetailsInquiryList(criteria);
    this.setState({
      isShowProgressBarPopup: true,
      progressLoadingText: "Executing...",
    });
  }
  loadSalesAndPurchaseDetailsInquiryList = (criteria) => {
    // if (SecurityAccessManager.SkuBatchInventoryInquiry_IsAccessible()) {
    ReportService.inquireSalesAndPurchaseDetails(
      criteria,
      this.loadSalesAndPurchasePageResponse,
      this.errorCallBack
    );
    // } else {
    //   this.inValidAccess(1);
    // }
  };
  loadSalesAndPurchasePageResponse = (response) => {
    this.showErrorMessage(response.data);
    if (response.data != null && response.data.resultBean != null) {
      let customerSalesDataList = [];
      let inquiryDataList = response.data.resultBean;
      if (!isEmptyArray(response.data.resultBean.infos)) {
        customerSalesDataList = response.data.resultBean.infos;
        this.setState({
          isShowPDFButton: true,
          isShowExcelButton: true,
        });
      }
      this.setState({
        isInquiryDatasFound: true,
        isShowResetButton: true,
        isShowClearCriteriaButton: false,
        inquiryDataList: customerSalesDataList,
        isCollapsible_open: false,
        isShowProgressBarPopup: false,
        progressLoadingText: "",
        inquiryData: inquiryDataList,

      });
    //  this.disable();
    }
    this.setState({
      isShowProgressBarPopup: false,
      progressLoadingText: "",
    });

  };

  inquiryPurchaseColumns = () => {
    const columns = new Array();
    // columns.push(
    //   new ColumnDefinition()
    //     .setDetails(
    //       "Vendor",
    //       "vendorCode",
    //       true
    //     )

    //     .setStyleDetails("left", "4", "", "wt-4", "wt-4")

    //    // .setClickDetails(true, false, this.viewFabricModule, null)
    // );
    // columns.push(
    //   new ColumnDefinition()
    //     .setDetails("VendorName", "vendorName", true)
    //     .setStyleDetails("left", "3", "", "wt-2", "wt-2")
    // );
    columns.push(
      new ColumnDefinition()
        .setDetails("FabricStyle", "fabricStyleCode", true)
        .setStyleDetails("left", "3", "", "wt-2", "wt-2")
    );
    columns.push(
      new ColumnDefinition()
        .setDetails("FabricStyleName", "fabricStyleName", true)
        .setStyleDetails("left", "3", "", "wt-2", "wt-2")
    );
    columns.push(
      new ColumnDefinition()
        .setDetails("Color", "colorCode", true)
        .setStyleDetails("left", "3", "", "wt-2", "wt-2")
    );
    columns.push(
      new ColumnDefinition()
        .setDetails("PoDate", "purchaseOrderDate", true)
        .setStyleDetails("left", "", "", "wt-2", "wt-2")
    );
    columns.push(
      new ColumnDefinition()
        .setDetails("PO", "purchaseOrderNumber", true)
        .setStyleDetails("left", "", "", "wt-2", "wt-2")
        .setClickDetails(true, false, this.viewPurchaseModule, null)
    );
    // columns.push(
    //   new ColumnDefinition()
    //     .setDetails("PRDate", "purchaseOrderReceiptNumber", true)
    //     .setStyleDetails("left", "", "", "wt-2", "wt-2")
    // );
    columns.push(
      new ColumnDefinition()
        .setDetails("PR", "purchaseOrderReceiptNumber", true)
        .setStyleDetails("left", "", "", "wt-2", "wt-2")
        .setClickDetails(true, false, this.viewPurchaseReceiptModule, null)
    );
    columns.push(
      new ColumnDefinition()
        .setDetails("ReceiptDate", "receiptDate", true)
        .setStyleDetails("left", "", "", "wt-2", "wt-2")
    );
    columns.push(
      new ColumnDefinition()
        .setDetails("UOM", "uomCode", true,)
        .setStyleDetails("left", "", "", "wt-2", "wt-2")
    );
    columns.push(
      new ColumnDefinition()
        .setDetails("ordQuantity", "orderQuantity", true, true)
        .setStyleDetails("left", "", "", "wt-2", "wt-2")
    );

    columns.push(
      new ColumnDefinition()
        .setDetails("RecdQuantity", "receivedQuantity", true, true)
        .setStyleDetails("left", "", "", "wt-2", "wt-2")
    );


    return columns;

  };
  resetPurchaseSales = () => {
    let vendorData = this.state.vendorData;
    let criteria = new SalesAndPurchaseInquiryCriteriaBean();
    criteria.companyCode = this.companyCode;
    criteria.vendorCode = vendorData.code;
    criteria.resultType = 1;
    criteria.fabricStyleColorCode = "";
   // criteria.vendorCode = "";
    this.setState({ criteria: criteria, isDisableFilterFields: false, });
    this.loadSalesAndPurchaseDetailsInquiryList(criteria);
  }
  errorCallBack = (error) => {
    ShowError(error);
    this.setState({
      isLoading: false,
      isShowProgressBarPopup: false,
      progressLoadingText: "",
    });
  };
  showErrorMessage = (response) => {
    if (response.errors != null) {
      let errMsg = "";
      let errList = [];
      response.errors.map(
        (err) => (
          (errMsg = errMsg + err.messageDescription),
          errList.push(err.messageDescription)
        )
      );
      this.setState({ error_list: errList });

      this.setState({
        alertMessage: errList,
        alertType: "danger",
        isShowAlert: true,

      });

    }
  };
  showInfoMessage = (response) => {
    if (response.infos != null) {
      let infoMsg = "";
      let successList = [];
      response.infos.map(
        (info) => (
          (infoMsg = infoMsg + info.messageDescription),
          successList.push(info.messageDescription)
        )
      );
      this.setState({
        alertMessage: successList,
        alertType: "success",
        isShowAlert: true,
      });
    }
  };
  hideAlertCallBack = (msgType, isDisplayed) => {
    this.setState({ isShowAlert: isDisplayed, error_list: [] });
  };
  closeModalCallBack = (isOpen) => {
    this.setState({
      // isShowFabricStyleModule: isOpen,
      // isShowInventoryAdjustmentModule: isOpen,
      isShowPurchaseReceiptModule: isOpen,
      isShowInvoiceModule: isOpen,
    //  // isShowPickticketModule: isOpen,
      // isShowInventoryTransferModule: isOpen,
      // isShowLogisticReceiptModule: isOpen,
       isShowPurchaseModule:isOpen,
      moduleForPopup: [],
    });
  };
 
  onPopupModalExit = () => {
    this.closeModalCallBack(false);
  };
viewPurchaseReceiptModule = (e, code, rowData) => {
  if (e.detail === 1) {
    if (code !== "" && code !== undefined) {
      this.setState({
        isShowPurchaseReceiptModule: true,
        moduleForPopup: (
          <PopupPurchaseReceiptModule
            code={code}
            onModuleExit={this.onPopupModalExit}
          />
        ),
      });
    }
  }
};
viewPurchaseModule = (e, code, rowData) => {
  if (e.detail === 1) {
    if (code !== "" && code !== undefined) {
      this.setState({
        isShowPurchaseModule: true,
        moduleForPopup: (
          <PopupPurchaseOrderModule
            code={code}
            onModuleExit={this.onPopupModalExit}
          />
        ),
      });
    }
  }
};
  render() {
    let vendorData = this.state.vendorData;
    let inquiryDataList = this.state.inquiryDataList;

    let criteria = this.state.criteria;
    return (
      <div>
        <Row>

          <Col className="align-items-left" sm="1">
            <FormLabel>Vendor</FormLabel>

          </Col>
          <Col sm="2">
            <InputTextbox
              name="code"
              readOnly={true}
              value={vendorData.code}
              disabled={true}
            />{" "}
          </Col>{" "}
          <Col sm="3">
            <InputTextbox
              name="description"
              readOnly={true}
              value={vendorData.description}
              disabled={true}
            />{" "}
          </Col>

          <Col sm="1">


            <FormLabel>FabricStyle</FormLabel>

          </Col>
          <Col sm="2">
            <InputTextbox
              showCriteriaDialog={true}
              // ref={fabricCodeRef}
              name="fabricStyleCode"
              onChange={this.fabricCodeOnChange}
              value={criteria.fabricStyleCode}
              lookupRequired={true}
              lookupHandler={this.state.fabricLookupHandler}
              enterKeyEventHandler={this.fabricEnterKeyEventHandler}
              autoCompleteListData={this.state.fabricPageListForAutoCompleteList}
              enableAutoCompleteTextBox={true}
              displayAutoCompleteList={this.displayAutoCompleteFabricList}
              showAutoCompleteList={this.state.showAutoCompleteFabricList}
              isMandatory={true}
            />
          </Col>
          <Col sm="3">
            <InputTextbox
              name="fabricStyleName"
              onChange={this.onChange}
              value={criteria.fabricStyleName}
              disabled={true}
            />
          </Col>
        </Row>
        <Row>
          <Col sm="1">
            <FormLabel>Color</FormLabel>
          </Col>
          <Col sm="2">
            <InputTextbox
              showCriteriaDialog={true}
              // ref={fabricCodeRef}
              name="fabricStyleColorCode"
              onChange={this.onColorCodeChange}
              value={criteria.fabricStyleColorCode}
              lookupRequired={true}
              lookupHandler={this.state.colorLookupHandler}
              enterKeyEventHandler={this.colorEnterKeyEvent}
              autoCompleteListData={this.state.colorPageListForAutoCompleteList}
              enableAutoCompleteTextBox={true}
              displayAutoCompleteList={this.displayAutoCompleteColorList}
              showAutoCompleteList={this.state.showAutoCompleteColorList}

              isMandatory={true}
            />
          </Col>
          <Col sm="1">
            <Button
              id="fabric_Add_Button"
              className="enterFocus"
              size="sm1"
              bssize="large"
              onClick={(e) => this.fetchPurchaseSales(e)}
            //  disabled={isDisabledFields}
            >
              {" "}
              Fetch{" "}
            </Button>
          </Col>{" "}
          <Col sm="1">
            <Button
              id="fabric_Add_Button"
              className="enterFocus"
              size="sm1"
              bssize="large"
              onClick={(e) => this.resetPurchaseSales(e)}
            // disabled={this.state.isResetCriteria}
            >
              {" "}
              Reset{" "}
            </Button>
          </Col>{" "}
        </Row>
        <div>
            {this.state.isInquiryDatasFound && (

              <div className="mt-3">
                <CustomTable
                  data={inquiryDataList}
                  columns={this.inquiryPurchaseColumns()}
                  // isEnableSpan={true}
                  label={"Inquiry Data List"}
                />
              </div>
            )}

            {/* {this.state.isInquiryDatasFound && this.state.resultType == 1 && (

            <div className="mt-3">
              <CustomTable
                data={inquiryDataList}
                columns={this.inquiryPurchaseColumns()}
                // isEnableSpan={true}
                label={"Inquiry Data List"}
              />
            </div>
          )} */}

          </div>
     
                  <MultiViewPopup
          isModulePopup={true}
          id="modulePopup"
          popupLvlClass={"popupSizeLevel0"}
          isShowPopup={this.state.isShowPurchaseModule}
          closeModalCallBack={this.closeModalCallBack}
          module={this.state.moduleForPopup}
        ></MultiViewPopup>
              <MultiViewPopup
          isModulePopup={true}
          id="modulePopup"
          popupLvlClass={"popupSizeLevel0"}
          isShowPopup={this.state.isShowPurchaseReceiptModule}
          closeModalCallBack={this.closeModalCallBack}
          module={this.state.moduleForPopup}
        ></MultiViewPopup>
      </div>
    );
  }
}
class VendorList extends React.Component {
  static contextType = AppContext;
  constructor(props) {
    super(props);
    this.vendorNameRef = React.createRef();
    this.state = {
      vendor_list: new Array(),
      vendorData: new VendorBean(),
      response: {},
      pageTitle: "Vendor Maintenance",
      modeText: "",
      pageList: new PageListBean(),
      criteria: new VendorSearchCriteria(),
      factoryCriteria: new VendorFactorySearchCriteria(),
      currentPageNumber: 0,
      totalCount: 0,
      attributeCache: new AttributeCacheBean(),
      companyCode: "",
      isVendorEntryFormOpen: false,
      isVendorListFormOpen: true,
      isShowNodes: false,
      isShowSaveButton: false,
      isShowClearCriteriaButton: false,
      isShowClearErrorButton: false,
      isShowBackButton: false,
      error_list: [],
      vendorFactoryList: new Array(),
      currentVendorFactory: new VendorFactoryBean(),
      vendorFactoryAddressData: new AddressBean(),
      isVendorFactoryListOpened: false,
      isVendorFactoryEntryOpened: false,
      isVendorPurchaseDetailsOpened: false,
      fOBCities: new Array(),
      shipmentTerms: new Array(),
      wareHouses: new Array(),
      incoTerms: new Array(),
      paymentTerms: new Array(),
      vendorTerms: new Array(),
      transportTypes: new Array(),
      countries: new Array(),
      uoms: new Array(),
      currencies: new Array(),
      shipVias: new Array(),
      states: new Array(),
      cities: new Array(),
      vendorCategories: new Array(),
      vendorTypes: new Array(),
      selectedNodeKey: "headerView",
      nodeList: [],
      isResetModule: false,
      moduleForPopup: [],
      isShowPopup: false,
      simplePopupContent: [],
      alertMessage: [],
      alertType: "",
      isShowAlert: false,
      isReadOnlyOrDisabled: false,
      isSpecialViewMode: false,
      vendorReceiptLookupHandler: null,
      isShowModuleSearchContainer: false,
      moduleKeyCode: NEW_ENTRY,
      isResetModule: false,
      moduleOrderStatus: "",
      disableFormFields: false,
      disabled: false,
      isResetView: true,
      isMaintenanceMode: true,
      isDisabledFields: false,
      showAutoCompleteLocationList: true,
      locationPageListForAutoCompleteList: new Array(),
      showAutoCompleteCityList: true,
      cityPageListForAutoCompleteList: new Array(),
      showAutoCompleteCountryList: true,
      countryPageListForAutoCompleteList: new Array(),
      showAutoCompleteStateList: true,
      statePageListForAutoCompleteList: new Array(),
      showAutoCompleteCountryCodeList: true,
      countryCodePageListForAutoCompleteList: new Array(),
      currencyCodePageListForAutoCompleteList: new Array(),
      showAutoCompleteCurrencyCodeList: true,
      shipViaPageListForAutoCompleteList: new Array(),
      showAutoCompleteShipViaList: true,
      shipmentTermPageListForAutoCompleteList: new Array(),
      showAutoCompleteShipmentTermList: true,
      fobPageListForAutoCompleteList: new Array(),
      showAutoCompleteFOBList: true,
      incoTermPageListForAutoCompleteList: new Array(),
      showAutoCompleteIncoTermList: true,
      categoryPageListForAutoCompleteList: new Array(),
      showAutoCompleteCategoryList: true,
      vendorTypePageListForAutoCompleteList: new Array(),
      showAutoCompleteVendorTypeList: true,
      isShowVendorOnOrderInq: false,
      isShowVendorPurchaseHistoryInq: false,
      order: "asc",
      sortField: "",
      disableVendorFactoryFields: false,
      showAutoCompleteVendorTermList: false,
      isReseted: false,
      isViewMode: false,
      is3PL:false,
    };
  }
  code = NEW_ENTRY;
  isLocked = false;
  fetchAttributesFromLocalStorage = () => {
    // let attribute_cache = JSON.parse(localStorage.getItem("attributeCache"));
    const attribute_cache = { ...this.cache };
    let fOBCitie = attribute_cache.fOBCities;
    let fOBCities=[];
    if (fOBCitie != null || fOBCitie != undefined) {
       fOBCities = ModuleUtils.isActiveAttribute(fOBCitie)
    }

    let shipmentTerm = attribute_cache.shipmentTerms;
    let shipmentTerms=[];
    if (shipmentTerm != null || shipmentTerm != undefined) {
       shipmentTerms = ModuleUtils.isActiveAttribute(shipmentTerm)
    }
    let warehouse = attribute_cache.warehouses;
     let warehouses =[];
    if (warehouse != null || warehouse != undefined) {
      warehouses = ModuleUtils.isActiveAttribute(warehouse)
    }
    let incoTerm = attribute_cache.incoTerms;
      let incoTerms =[];
    if (incoTerm != null || incoTerm != undefined) {
      incoTerms = ModuleUtils.isActiveAttribute(incoTerm)
    }
    let paymentTerm = attribute_cache.paymentTerms;
     let paymentTerms =[];
    if (paymentTerm != null || paymentTerm != undefined) {
    paymentTerms = ModuleUtils.isActiveAttribute(paymentTerm)
    }
    let vendorTerm = attribute_cache.vendorTerms;
    let vendorTerms =[];
    if (vendorTerm != null || vendorTerm != undefined) {
      vendorTerms = ModuleUtils.isActiveAttribute(vendorTerm)
    }
    
    let transportType = attribute_cache.transportTypes;
    let transportTypes =[];
    if (transportType != null || transportType != undefined) {
        transportTypes = ModuleUtils.isActiveAttribute(transportType)
    }
    
    let uom = attribute_cache.uoms;
    let uoms =[];
    if (uom != null || uom != undefined) {
      uoms = ModuleUtils.isActiveAttribute(uom)
    }

    let countrie = attribute_cache.countries;
    let countries =[]
    if (countrie != null || countrie != undefined) {
      countries = ModuleUtils.isActiveAttribute(countrie)
    }
    let currencie = attribute_cache.currencies;
    let currencies =[];
    if (currencie != null || currencie != undefined) {
      currencies = ModuleUtils.isActiveAttribute(currencie)
    }
    let shipVia = attribute_cache.vendorShipVias;
     let shipVias =[];
    if (shipVia != null || shipVia != undefined) {
        shipVias = ModuleUtils.isActiveAttribute(shipVia)
    }
    let state = attribute_cache.states;
     let states = [];
    if (state != null || state != undefined) {
     states = ModuleUtils.isActiveAttribute(state)
    }
    let citie = attribute_cache.cities;
      let cities =[];
    if (citie != null || citie != undefined) {
       cities = ModuleUtils.isActiveAttribute(citie)
    }
    let vendorCategorie = attribute_cache.vendorCategories;
    let vendorCategories =[];
    if (vendorCategorie != null || vendorCategorie != undefined) {
      vendorCategories = ModuleUtils.isActiveAttribute(vendorCategorie)
    }

    let vendorType = attribute_cache.vendorTypes;
      let vendorTypes = [];
    if (vendorType != null || vendorType != undefined) {
      vendorTypes = ModuleUtils.isActiveAttribute(vendorType)

    }
    this.setState({
      fOBCities:fOBCities,
      shipmentTerms:shipmentTerms,
      wareHouses:warehouses,
      incoTerms:incoTerms,
      paymentTerms:paymentTerms,
      vendorTerms:vendorTerms,
      transportTypes:transportTypes,
      uoms:uoms,
      countries:countries,
      currencies:currencies,
      shipVias:shipVias,
      states:states,
      cities:cities,
      vendorCategories:vendorCategories,
      vendorTypes:vendorTypes
    })
  };
  componentDidMount() {
    const { appData } = this.context;
    const { cache } = appData;
    this.cache = cache;
    if (ConfigManager.isPurchaseBasedOnCustomerFlag()) {
      this.state.is3PL = true;
      this.setState({
        is3PL: true,
      });
    }
    this.fetchAttributesFromLocalStorage();
    this.companyCode = appData.companyCode;

    this.state.criteria = new VendorSearchCriteria();

    this.state.criteria.companyCode = this.companyCode;
    this.state.pageList = new PageListBean();
    this.state.pageList.pageSize = 50;

    this.initLookupHandlers();
    let isReadOnly = this.state.isReadOnlyOrDisabled;
    let isSpecialViewMode = this.state.isSpecialViewMode;
    if (this.props.isSpecialViewMode) {
      isSpecialViewMode = this.props.isSpecialViewMode;
      isReadOnly = this.props.isSpecialViewMode;
    }
    this.setState({
      isReadOnlyOrDisabled: isReadOnly,
      isSpecialViewMode: isSpecialViewMode,
    });

    if (this.props.vendorCode !== "" && this.props.vendorCode !== undefined) {
      this.code = this.props.vendorCode;

      this.editVendor(this.props.vendorCode);
      this.setState({
        isResetView: false,
        isMaintenanceMode: false,
        isDisabledFields: true,
        isViewMode: false,
      });
    } else {
      this.addNewEntry();
    }
    // this.loadVendorPage();
  }
  moduleCaption = "Vendor Maintenance";
  setFocus = () => {
    this.vendorNameRef.current.focus();
  };
  initLookupHandlers = () => {
    let vendorLookupHandler = new VendorLookupHandler(
      this.companyCode,
      "Vendor"
    );
    this.setState({ vendorLookupHandler: vendorLookupHandler });
  };
  #region;
  loadFirst = () => {
    this.loadPage(1);
  };
  loadPrevious = () => {
    let currentPage = this.state.pageList.currentPage;
    let previousPage = currentPage - 1;
    this.loadPage(previousPage);
  };
  loadNext = () => {
    let currentPage = this.state.pageList.currentPage;
    let nextPage = currentPage + 1;
    this.loadPage(nextPage);
  };
  loadLast = () => {
    let pageSize = this.state.pageList.pageSize;
    let totalCount = this.state.pageList.totalCount;
    let totalPages = totalCount / pageSize;
    totalPages += totalCount % pageSize == 0 ? 0 : 1;
    this.loadPage(totalPages);
  };
  loadPage = (pageNumber) => {
    let pageList = this.state.pageList;
    let pageInput = new PageListBean();
    pageInput.pageSize = 50;
    pageInput.currentPage = pageNumber;
    if (pageList != null) pageInput.totalCount = pageList.totalCount;
    this.state.pageList = pageInput;
    this.loadVendorPage();
  };

  showErrorMessage = (response) => {
    if (response.errors != null) {
      let errMsg = "";
      let errList = this.state.error_list;
      response.errors.map(
        (err) => (
          (errMsg = errMsg + err.messageDescription),
          errList.push(err.messageDescription)
        )
      );
      this.setState({ error_list: errList });
      this.setState({
        alertMessage: errList,
        alertType: "danger",
        isShowAlert: true,
      });
    }
  };
  handleresponse = (response) => {
    if (response.errors != null) {
      let errMsg = "";
      let errList = this.state.error_list;
      response.errors.map(
        (err) => (
          (errMsg = errMsg + err.messageDescription),
          errList.push(err.messageDescription)
        )
      );
      this.setState({ error_list: errList });
      this.setState({
        alertMessage: errList,
        alertType: "danger",
        isShowAlert: true,
      });
    }
    if (response.infos != null) {
      let infoMsg = "";
      let successList = [];
      response.infos.map(
        (info) => (
          (infoMsg = infoMsg + info.messageDescription),
          successList.push(info.messageDescription)
        )
      );
      this.setState({
        alertMessage: successList,
        alertType: "success",
        isShowAlert: true,
      });
    }
  };
  showInfoMessage = (response) => {
    if (response.infos != null) {
      let infoMsg = "";
      let successList = [];
      response.infos.map(
        (info) => (
          (infoMsg = infoMsg + info.messageDescription),
          successList.push(info.messageDescription)
        )
      );
      this.setState({
        alertMessage: successList,
        alertType: "success",
        isShowAlert: true,
      });
    }
  };
  save = () => {
    if (this.state.selectedNodeKey == "headerView") {
      this.saveVendor(this.state.vendorData, this.state.addressData);
    } else if (this.state.selectedNodeKey == "vendorFactoryView") {
      this.saveVendorFactory(
        this.state.currentVendorFactory,
        this.state.vendorFactoryAddressData
      );
    } else {
      this.saveVendor(this.state.vendorData, this.state.addressData);
    }
  };

  clearError = () => {
    this.setState({ error_list: [] });
  };
  onChange = (e) => {
    let criteria = this.state.criteria;

    if (e.target.name == "criteriakey") {
      criteria["vendorNameContains"] = e.target.value;
      criteria["vendorCodeStartsWith"] = e.target.value;
    }

    this.setState({ criteria: criteria });
  };
  onLocationChange = (e) => {
    let locationCode = e.target.value;
    this.state.showAutoCompleteLocationList = true;

    let temp_vendorData = this.state.vendorData;
    let showAutoCompleteList = this.state.showAutoCompleteLocationList;

    if (isEmpty(locationCode)) {
      this.state.showAutoCompleteLocationList = false;
      let showAutoCompleteList = this.state.showAutoCompleteLocationList;
      let soLine = this.state.vendorData;
      soLine.locationCode = "";
      let suggestion = [];

      this.setState({
        showAutoCompleteList: showAutoCompleteList,
        vendorData: soLine,
        locationPageListForAutoCompleteList: suggestion,
      });
    } else if (showAutoCompleteList === true && locationCode !== "") {
      this.readLocationBySearchString(locationCode);
    }
    if (e.target.name == "locationCode") {
      temp_vendorData["locationCode"] = e.target.value;
      let productType_List = this.state.wareHouses;
      productType_List.map((pdtType) => {
        if (pdtType.code == e.target.value) {
          temp_vendorData["locationCode"] = pdtType.code;
          this.state.showAutoCompleteLocationList = false;
          let showAutoCompleteList = this.state.showAutoCompleteLocationList;
          this.setState({ showAutoCompleteLocationList: showAutoCompleteList });
        }
      });
    }
    this.setState({ vendorData: temp_vendorData });
  };
  readLocationBySearchString(searchString) {
    let locationData = this.state.wareHouses;
    let simpleAutoCompleteList = new Array();
    if (locationData.length > 0 && locationData != null) {
      locationData.map((locations) => {
        let simpleItemBean = {
          code: locations.code,
          description: locations.description,
        };
        simpleAutoCompleteList.push(simpleItemBean);
      });
    }
    let userInput = searchString;

    let filteredSuggestions = new Array();

    filteredSuggestions = simpleAutoCompleteList.filter(
      (simpleAutoCompleteLocationLists) =>
        simpleAutoCompleteLocationLists.code
          .toLowerCase()
          .indexOf(userInput.toLowerCase()) > -1
    );
    this.setState({ locationPageListForAutoCompleteList: filteredSuggestions });
  }
  locationEnterKeyEventHandler = (e) => {
    let temp_vendorData = this.state.vendorData;
    let locationCode = e.target.value;

    temp_vendorData["locationCode"] = e.target.value;
    let productType_List = this.state.wareHouses;
    let locationCodeBean = null;
    productType_List.map((pdtType) => {
      if (pdtType.code == e.target.value) {
        locationCodeBean = pdtType;
      }
    });
    if (!isEmpty(locationCodeBean)) {
      let temp_vendorData = this.state.vendorData;
      temp_vendorData.locationCode = locationCodeBean.code;
      this.setState({
        vendorData: temp_vendorData,
        locationPageListForAutoCompleteList: new Array(),
      });
    }
  };
  displayAutoCompleteLocationList = (showAutoCompleteList) => {
    this.setState({ showAutoCompleteLocationList: showAutoCompleteList });
  };
  onCategoryChange = (e) => {
    let vendorCategory = e.target.value;
    this.state.showAutoCompleteCategoryList = true;

    let temp_vendorData = this.state.vendorData;
    let showAutoCompleteList = this.state.showAutoCompleteCategoryList;

    if (isEmpty(vendorCategory)) {
      this.state.showAutoCompleteCategoryList = false;
      let showAutoCompleteList = this.state.showAutoCompleteCategoryList;
      let vendorData = this.state.vendorData;
      vendorData.vendorCategory = "";
      let suggestion = [];

      this.setState({
        showAutoCompleteList: showAutoCompleteList,
        vendorData: vendorData,
        categoryPageListForAutoCompleteList: suggestion,
      });
    } else if (showAutoCompleteList === true && vendorCategory !== "") {
      this.readCategoryBySearchString(vendorCategory);
    }
    if (e.target.name == "vendorCategoryCode") {
      temp_vendorData["vendorCategoryCode"] = e.target.value;
      let categories_list = this.state.vendorCategories;
      categories_list.map((category) => {
        if (category.code == e.target.value) {
          temp_vendorData["vendorCategoryCode"] = category.code;
          this.state.showAutoCompleteCategoryList = false;
          let showAutoCompleteList = this.state.showAutoCompleteCategoryList;
          this.setState({ showAutoCompleteCategoryList: showAutoCompleteList });
        }
      });
    }
    this.setState({ vendorData: temp_vendorData });
  };
  readCategoryBySearchString(searchString) {
    let categoryData = this.state.vendorCategories;
    let simpleAutoCompleteList = new Array();
    if (categoryData.length > 0 && categoryData != null) {
      categoryData.map((category) => {
        let simpleItemBean = {
          code: category.code,
          description: category.description,
        };
        simpleAutoCompleteList.push(simpleItemBean);
      });
    }
    let userInput = searchString;

    let filteredSuggestions = new Array();

    filteredSuggestions = simpleAutoCompleteList.filter(
      (ln) => ln.code.toLowerCase().indexOf(userInput.toLowerCase()) > -1
    );
    this.setState({ categoryPageListForAutoCompleteList: filteredSuggestions });
  }
  categoryEnterKeyEventHandler = (e) => {
    let temp_vendorData = this.state.vendorData;
    let vendorCategory = e.target.value;

    temp_vendorData["vendorCategoryCode"] = e.target.value;
    let categories_list = this.state.vendorCategories;
    let vendorCategoryBean = null;
    categories_list.map((category) => {
      if (category.code == e.target.value) {
        vendorCategoryBean = category;
      }
    });
    if (!isEmpty(vendorCategoryBean)) {
      let temp_vendorData = this.state.vendorData;
      temp_vendorData.vendorCategoryCode = vendorCategoryBean.code;
      this.setState({
        vendorData: temp_vendorData,
        categoryPageListForAutoCompleteList: new Array(),
      });
    }
  };
  displayAutoCompleteCategoryList = (showAutoCompleteList) => {
    this.setState({ showAutoCompleteCategoryList: showAutoCompleteList });
  };
  onVendorTypeChange = (e) => {
    let vendorTypeCode = e.target.value;
    this.state.showAutoCompleteVendorTypeList = true;

    let temp_vendorData = this.state.vendorData;
    let showAutoCompleteList = this.state.showAutoCompleteVendorTypeList;

    if (isEmpty(vendorTypeCode)) {
      this.state.showAutoCompleteVendorTypeList = false;
      let showAutoCompleteList = this.state.showAutoCompleteVendorTypeList;
      let vendorData = this.state.vendorData;
      vendorData.vendorTypeCode = "";
      let suggestion = [];

      this.setState({
        showAutoCompleteList: showAutoCompleteList,
        vendorData: vendorData,
        vendorTypePageListForAutoCompleteList: suggestion,
      });
    } else if (showAutoCompleteList === true && vendorTypeCode !== "") {
      this.readVendorTypeBySearchString(vendorTypeCode);
    }
    if (e.target.name == "vendorTypeCode") {
      temp_vendorData["vendorTypeCode"] = e.target.value;
      let vendorType_List = this.state.vendorTypes;
      vendorType_List.map((vendorType) => {
        if (vendorType.code == e.target.value) {
          temp_vendorData["vendorTypeCode"] = vendorType.code;
          this.state.showAutoCompleteVendorTypeList = false;
          let showAutoCompleteList = this.state.showAutoCompleteVendorTypeList;
          this.setState({
            showAutoCompleteVendorTypeList: showAutoCompleteList,
          });
        }
      });
    }
    this.setState({ vendorData: temp_vendorData });
  };
  readVendorTypeBySearchString(searchString) {
    let vendorTypeData = this.state.vendorTypes;
    let simpleAutoCompleteList = new Array();
    if (vendorTypeData.length > 0 && vendorTypeData != null) {
      vendorTypeData.map((vendorType) => {
        let simpleItemBean = {
          code: vendorType.code,
          description: vendorType.description,
        };
        simpleAutoCompleteList.push(simpleItemBean);
      });
    }
    let userInput = searchString;

    let filteredSuggestions = new Array();

    filteredSuggestions = simpleAutoCompleteList.filter(
      (ln) => ln.code.toLowerCase().indexOf(userInput.toLowerCase()) > -1
    );
    this.setState({
      vendorTypePageListForAutoCompleteList: filteredSuggestions,
    });
  }
  vendorTypeEnterKeyEventHandler = (e) => {
    let temp_vendorData = this.state.vendorData;
    let vendorTypeCode = e.target.value;

    temp_vendorData["vendorTypeCode"] = e.target.value;
    let vendorType_List = this.state.vendorTypes;
    let vendorTypeBean = null;
    vendorType_List.map((vendorType) => {
      if (vendorType.code == e.target.value) {
        vendorTypeBean = vendorType;
      }
    });
    if (!isEmpty(vendorTypeBean)) {
      let temp_vendorData = this.state.vendorData;
      temp_vendorData.vendorTypeCode = vendorTypeBean.code;
      this.setState({
        vendorData: temp_vendorData,
        vendorTypePageListForAutoCompleteList: new Array(),
      });
    }
  };
  displayAutoCompleteVendorTypeList = (showAutoCompleteList) => {
    this.setState({ showAutoCompleteVendorTypeList: showAutoCompleteList });
  };
  onVendorTermChange = (e) => {
    let vendorTerm = e.target.value;
    this.state.showAutoCompleteVendorTermList = true;
    let temp_vendorData = this.state.vendorData;
    let showAutoCompleteList = this.state.showAutoCompleteVendorTermList;

    if (isEmpty(vendorTerm)) {
      this.state.showAutoCompleteVendorTermList = false;
      let showAutoCompleteList = this.state.showAutoCompleteVendorTermList;
      let temp_vendorData = this.state.vendorData;
      temp_vendorData.buyingTermsCode = "";
      let suggestion = [];

      this.setState({
        showAutoCompleteVendorTermList: showAutoCompleteList,
        vendorData: temp_vendorData,
        vendorTermPageListForAutoCompleteList: suggestion,
      });
    } else if (showAutoCompleteList === true && vendorTerm !== "") {
      this.readVendorTermBySearchString(vendorTerm);
    }
    if (e.target.name == "buyingTermsCode") {
      temp_vendorData[e.target.name] = e.target.value;
      let buyingTermsCodeList = this.state.vendorTerms;
      buyingTermsCodeList.map((pdtType) => {
        if (pdtType.code == e.target.value) {
          temp_vendorData["buyingTermsCode"] = pdtType.code;
          this.state.showAutoCompleteVendorTermList = false;
          let showAutoCompleteList = this.state.showAutoCompleteVendorTermList;
          this.setState({
            showAutoCompleteVendorTermList: showAutoCompleteList,
          });
        }
      });
    }

    this.setState({
      vendorData: temp_vendorData,
    });
  };

  readVendorTermBySearchString(searchString) {
    let vendorTermData = this.state.vendorTerms;
    let simpleAutoCompleteList = new Array();
    if (vendorTermData.length > 0 && vendorTermData != null) {
      vendorTermData.map((vendorTerms) => {
        let simpleItemBean = {
          code: vendorTerms.code,
          description: vendorTerms.description,
        };
        simpleAutoCompleteList.push(simpleItemBean);
      });
    }
    let userInput = searchString;

    let filteredSuggestions = new Array();

    filteredSuggestions = simpleAutoCompleteList.filter(
      (simpleAutoCompleteVendorTermLists) =>
        simpleAutoCompleteVendorTermLists.code
          .toLowerCase()
          .indexOf(userInput.toLowerCase()) > -1
    );
    this.setState({
      vendorTermPageListForAutoCompleteList: filteredSuggestions,
    });
  }
  vendorTermEnterKeyEventHandler = (e) => {
    let temp_vendorData = this.state.vendorData;
    temp_vendorData[e.target.name] = e.target.value;
    let vendorTermCode_List = this.state.vendorTerms;
    let vendorTermCodeBean = null;
    vendorTermCode_List.map((ln) => {
      if (ln.code == e.target.value) {
        vendorTermCodeBean = ln;
      }
    });
    if (!isEmpty(vendorTermCodeBean)) {
      temp_vendorData.buyingTermsCode = vendorTermCodeBean.code;

      this.setState({
        vendorData: temp_vendorData,
        vendorTermPageListForAutoCompleteList: new Array(),
      });
    }
  };
  displayAutoCompleteBuyingTermsList = (showAutoCompleteList) => {
    this.setState({ showAutoCompleteVendorTermList: showAutoCompleteList });
  };
  onCityChange = (e) => {
    let city = e.target.value;
    this.state.showAutoCompleteCityList = true;

    let temp_addressData = this.state.addressData;
    let showAutoCompleteList = this.state.showAutoCompleteCityList;

    if (isEmpty(city)) {
      this.state.showAutoCompleteCityList = false;
      let showAutoCompleteList = this.state.showAutoCompleteCityList;
      let soLine = this.state.addressData;
      soLine.city = "";
      let suggestion = [];

      this.setState({
        showAutoCompleteList: showAutoCompleteList,
        addressData: soLine,
        cityPageListForAutoCompleteList: suggestion,
      });
    } else if (showAutoCompleteList === true && city !== "") {
      this.readcityBySearchString(city);
    }
    if (e.target.name == "city") {
      temp_addressData["city"] = e.target.value;
      let productType_List = this.state.cities;
      productType_List.map((pdtType) => {
        if (pdtType.code == e.target.value) {
          temp_addressData["city"] = pdtType.code;
          this.state.showAutoCompleteCityList = false;
          let showAutoCompleteList = this.state.showAutoCompleteCityList;
          this.setState({ showAutoCompleteList: showAutoCompleteList });
        }
      });
    }
    this.setState({ addressData: temp_addressData });
  };
  readcityBySearchString(searchString) {
    let cityData = this.state.cities;
    let simpleAutoCompleteList = new Array();
    if (cityData.length > 0 && cityData != null) {
      cityData.map((cityDatas) => {
        let simpleItemBean = {
          code: cityDatas.code,
          description: cityDatas.description,
        };
        simpleAutoCompleteList.push(simpleItemBean);
      });
    }
    let userInput = searchString;

    let filteredSuggestions = new Array();

    filteredSuggestions = simpleAutoCompleteList.filter(
      (simpleAutoCompletecityLists) =>
        simpleAutoCompletecityLists.code
          .toLowerCase()
          .indexOf(userInput.toLowerCase()) > -1
    );
    this.setState({ cityPageListForAutoCompleteList: filteredSuggestions });
  }
  cityEnterKeyEvent = (e) => {
    let temp_addressData = this.state.addressData;
    let city = e.target.value;

    temp_addressData["city"] = e.target.value;
    let productType_List = this.state.cities;
    let cityBean = null;
    productType_List.map((pdtType) => {
      if (pdtType.code == e.target.value) {
        cityBean = pdtType;
      }
    });
    if (!isEmpty(cityBean)) {
      let temp_addressData = this.state.addressData;
      temp_addressData.city = cityBean.code;
      this.setState({
        addressData: temp_addressData,
        cityPageListForAutoCompleteList: new Array(),
      });
    }
  };
  onCountryChange = (e) => {
    let manufacturingCountryCode = e.target.value;
    this.state.showAutoCompleteCountryList = true;

    let temp_vendorData = this.state.vendorData;
    let showAutoCompleteList = this.state.showAutoCompleteCountryList;

    if (isEmpty(manufacturingCountryCode)) {
      this.state.showAutoCompleteCountryList = false;
      let showAutoCompleteList = this.state.showAutoCompleteCountryList;
      let soLine = this.state.vendorData;
      soLine.manufacturingCountryCode = "";
      let suggestion = [];

      this.setState({
        showAutoCompleteList: showAutoCompleteList,
        vendorData: soLine,
        countryPageListForAutoCompleteList: suggestion,
      });
    } else if (
      showAutoCompleteList === true &&
      manufacturingCountryCode !== ""
    ) {
      this.readcountryBySearchString(manufacturingCountryCode);
    }
    if (e.target.name == "manufacturingCountryCode") {
      temp_vendorData["manufacturingCountryCode"] = e.target.value;
      let productType_List = this.state.countries;
      productType_List.map((pdtType) => {
        if (pdtType.code == e.target.value) {
          temp_vendorData["manufacturingCountryCode"] = pdtType.code;
          this.state.showAutoCompleteCountryList = false;
          let showAutoCompleteList = this.state.showAutoCompleteCountryList;
          this.setState({ showAutoCompleteList: showAutoCompleteList });
        }
      });
    }
    this.setState({ vendorData: temp_vendorData });
  };
  readcountryBySearchString(searchString) {
    let countryData = this.state.countries;
    let simpleAutoCompleteList = new Array();
    if (countryData.length > 0 && countryData != null) {
      countryData.map((countryDatas) => {
        let simpleItemBean = {
          code: countryDatas.code,
          description: countryDatas.description,
        };
        simpleAutoCompleteList.push(simpleItemBean);
      });
    }
    let userInput = searchString;

    let filteredSuggestions = new Array();

    filteredSuggestions = simpleAutoCompleteList.filter(
      (simpleAutoCompletecountryLists) =>
        simpleAutoCompletecountryLists.code
          .toLowerCase()
          .indexOf(userInput.toLowerCase()) > -1
    );
    this.setState({ countryPageListForAutoCompleteList: filteredSuggestions });
  }
  countryEnterKeyEvent = (e) => {
    let temp_vendorData = this.state.vendorData;
    let manufacturingCountryCode = e.target.value;

    temp_vendorData["manufacturingCountryCode"] = e.target.value;
    let productType_List = this.state.countries;
    let countryBean = null;
    productType_List.map((pdtType) => {
      if (pdtType.code == e.target.value) {
        countryBean = pdtType;
      }
    });
    if (!isEmpty(countryBean)) {
      let temp_vendorData = this.state.vendorData;
      temp_vendorData.manufacturingCountryCode = countryBean.code;
      this.setState({
        vendorData: temp_vendorData,
        countryPageListForAutoCompleteList: new Array(),
      });
    }
  };
  onCountryCodeChange = (e) => {
    let country = e.target.value;
    this.state.showAutoCompleteCountryCodeList = true;

    let temp_addressData = this.state.addressData;
    let showAutoCompleteList = this.state.showAutoCompleteCountryCodeList;

    if (isEmpty(country)) {
      this.state.showAutoCompleteCountryCodeList = false;
      let showAutoCompleteList = this.state.showAutoCompleteCountryCodeList;
      let soLine = this.state.addressData;
      soLine.country = "";
      let suggestion = [];

      this.setState({
        showAutoCompleteList: showAutoCompleteList,
        addressData: soLine,
        countryCodePageListForAutoCompleteList: suggestion,
      });
    } else if (showAutoCompleteList === true && country !== "") {
      this.readcountryCodeBySearchString(country);
    }
    if (e.target.name == "country") {
      temp_addressData["country"] = e.target.value;
      let productType_List = this.state.countries;
      productType_List.map((pdtType) => {
        if (pdtType.code == e.target.value) {
          temp_addressData["country"] = pdtType.code;
          this.state.showAutoCompleteCountryCodeList = false;
          let showAutoCompleteList = this.state.showAutoCompleteCountryCodeList;
          this.setState({ showAutoCompleteList: showAutoCompleteList });
        }
      });
    }
    this.setState({ addressData: temp_addressData });
  };
  readcountryCodeBySearchString(searchString) {
    let countryData = this.state.countries;
    let simpleAutoCompleteList = new Array();
    if (countryData.length > 0 && countryData != null) {
      countryData.map((countryDatas) => {
        let simpleItemBean = {
          code: countryDatas.code,
          description: countryDatas.description,
        };
        simpleAutoCompleteList.push(simpleItemBean);
      });
    }
    let userInput = searchString;

    let filteredSuggestions = new Array();

    filteredSuggestions = simpleAutoCompleteList.filter(
      (simpleAutoCompletecountryLists) =>
        simpleAutoCompletecountryLists.code
          .toLowerCase()
          .indexOf(userInput.toLowerCase()) > -1
    );
    this.setState({
      countryCodePageListForAutoCompleteList: filteredSuggestions,
    });
  }
  countryCodeEnterKeyEvent = (e) => {
    let temp_addressData = this.state.addressData;
    let country = e.target.value;

    temp_addressData["country"] = e.target.value;
    let productType_List = this.state.countries;
    let countryBean = null;
    productType_List.map((pdtType) => {
      if (pdtType.code == e.target.value) {
        countryBean = pdtType;
      }
    });
    if (!isEmpty(countryBean)) {
      let temp_addressData = this.state.addressData;
      temp_addressData.country = countryBean.code;
      this.setState({
        addressData: temp_addressData,
        countryCodePageListForAutoCompleteList: new Array(),
      });
    }
  };
  onStateChange = (e) => {
    let state = e.target.value;
    this.state.showAutoCompleteStateList = true;

    let temp_addressData = this.state.addressData;
    let showAutoCompleteList = this.state.showAutoCompleteStateList;

    if (isEmpty(state)) {
      this.state.showAutoCompleteStateList = false;
      let showAutoCompleteList = this.state.showAutoCompleteStateList;
      let soLine = this.state.addressData;
      soLine.state = "";
      let suggestion = [];

      this.setState({
        showAutoCompleteList: showAutoCompleteList,
        addressData: soLine,
        statePageListForAutoCompleteList: suggestion,
      });
    } else if (showAutoCompleteList === true && state !== "") {
      this.readstateBySearchString(state);
    }
    if (e.target.name == "state") {
      temp_addressData["state"] = e.target.value;
      let productType_List = this.state.states;
      productType_List.map((pdtType) => {
        if (pdtType.code == e.target.value) {
          temp_addressData["state"] = pdtType.code;
          this.state.showAutoCompleteStateList = false;
          let showAutoCompleteList = this.state.showAutoCompleteStateList;
          this.setState({ showAutoCompleteList: showAutoCompleteList });
        }
      });
    }
    this.setState({ addressData: temp_addressData });
  };
  readstateBySearchString(searchString) {
    let stateData = this.state.states;
    let simpleAutoCompleteList = new Array();
    if (stateData.length > 0 && stateData != null) {
      stateData.map((stateDatas) => {
        let simpleItemBean = {
          code: stateDatas.code,
          description: stateDatas.description,
        };
        simpleAutoCompleteList.push(simpleItemBean);
      });
    }
    let userInput = searchString;

    let filteredSuggestions = new Array();

    filteredSuggestions = simpleAutoCompleteList.filter(
      (simpleAutoCompletestateLists) =>
        simpleAutoCompletestateLists.code
          .toLowerCase()
          .indexOf(userInput.toLowerCase()) > -1
    );
    this.setState({ statePageListForAutoCompleteList: filteredSuggestions });
  }
  stateEnterKeyEvent = (e) => {
    let temp_addressData = this.state.addressData;
    let state = e.target.value;

    temp_addressData["state"] = e.target.value;
    let productType_List = this.state.states;
    let stateBean = null;
    productType_List.map((pdtType) => {
      if (pdtType.code == e.target.value) {
        stateBean = pdtType;
      }
    });
    if (!isEmpty(stateBean)) {
      let temp_addressData = this.state.addressData;
      temp_addressData.state = stateBean.code;
      this.setState({
        addressData: temp_addressData,
        statePageListForAutoCompleteList: new Array(),
      });
    }
  };
  onShipViaChange = (e) => {
    let shipViaCode = e.target.value;
    this.state.showAutoCompleteShipViaList = true;

    let temp_vendorData = this.state.vendorData;
    let showAutoCompleteList = this.state.showAutoCompleteShipViaList;

    if (isEmpty(shipViaCode)) {
      this.state.showAutoCompleteShipViaList = false;
      let showAutoCompleteList = this.state.showAutoCompleteShipViaList;
      let soLine = this.state.vendorData;
      soLine.shipViaCode = "";
      let suggestion = [];

      this.setState({
        showAutoCompleteList: showAutoCompleteList,
        vendorData: soLine,
        shipViaPageListForAutoCompleteList: suggestion,
      });
    } else if (showAutoCompleteList === true && shipViaCode !== "") {
      this.readShipViaBySearchString(shipViaCode);
    }
    if (e.target.name == "shipViaCode") {
      temp_vendorData["shipViaCode"] = e.target.value;
      let productType_List = this.state.shipVias;
      productType_List.map((pdtType) => {
        if (pdtType.code == e.target.value) {
          temp_vendorData["shipViaCode"] = pdtType.code;
          this.state.showAutoCompleteShipViaList = false;
          let showAutoCompleteList = this.state.showAutoCompleteShipViaList;
          this.setState({ showAutoCompleteList: showAutoCompleteList });
        }
      });
    }
    this.setState({ vendorData: temp_vendorData });
  };
  readShipViaBySearchString(searchString) {
    let shipViaCodeData = this.state.shipVias;
    let simpleAutoCompleteList = new Array();
    if (shipViaCodeData.length > 0 && shipViaCodeData != null) {
      shipViaCodeData.map((shipViaCodeDatas) => {
        let simpleItemBean = {
          code: shipViaCodeDatas.code,
          description: shipViaCodeDatas.description,
        };
        simpleAutoCompleteList.push(simpleItemBean);
      });
    }
    let userInput = searchString;

    let filteredSuggestions = new Array();

    filteredSuggestions = simpleAutoCompleteList.filter(
      (simpleAutoCompleteShipViaLists) =>
        simpleAutoCompleteShipViaLists.code
          .toLowerCase()
          .indexOf(userInput.toLowerCase()) > -1
    );
    this.setState({ shipViaPageListForAutoCompleteList: filteredSuggestions });
  }
  shipViaEnterKeyEvent = (e) => {
    let temp_vendorData = this.state.vendorData;
    let shipViaCode = e.target.value;

    temp_vendorData["shipViaCode"] = e.target.value;
    let shipViaList = this.state.shipVias;
    let shipViaBean = null;
    shipViaList.map((shipVia_List) => {
      if (shipVia_List.code == e.target.value) {
        shipViaBean = shipVia_List;
      }
    });
    if (!isEmpty(shipViaBean)) {
      let temp_vendorData = this.state.vendorData;
      temp_vendorData.shipViaCode = shipViaBean.code;
      this.setState({
        vendorData: temp_vendorData,
        shipViaPageListForAutoCompleteList: new Array(),
      });
    }
  };
  displayAutoCompleteShipViaList = (showAutoCompleteList) => {
    this.setState({ showAutoCompleteShipViaList: showAutoCompleteList });
  };
  onShipmentTermChange = (e) => {
    let shipmentTerm = e.target.value;
    this.state.showAutoCompleteShipmentTermList = true;

    let temp_vendorData = this.state.vendorData;
    let showAutoCompleteList = this.state.showAutoCompleteShipmentTermList;

    if (isEmpty(shipmentTerm)) {
      this.state.showAutoCompleteShipmentTermList = false;
      let showAutoCompleteList = this.state.showAutoCompleteShipmentTermList;
      let temp_vendorData = this.state.vendorData;
      temp_vendorData.shipmentTermsCode = "";
      let suggestion = [];

      this.setState({
        showAutoCompleteList: showAutoCompleteList,
        vendorData: temp_vendorData,
        shipmentTermPageListForAutoCompleteList: suggestion,
      });
    } else if (showAutoCompleteList === true && shipmentTerm !== "") {
      this.readShipmentTermBySearchString(shipmentTerm);
    }
    if (e.target.name == "shipmentTermsCode") {
      temp_vendorData[e.target.name] = e.target.value;
      let shipmentTermsCodeList = this.state.shipmentTerms;
      shipmentTermsCodeList.map((pdtType) => {
        if (pdtType.code == e.target.value) {
          temp_vendorData["shipmentTermsCode"] = pdtType.code;
          this.state.showAutoCompleteShipmentTermList = false;
          let showAutoCompleteList =
            this.state.showAutoCompleteShipmentTermList;
          this.setState({
            showAutoCompleteShipmentTermList: showAutoCompleteList,
          });
        }
      });
    }

    this.setState({
      vendorData: temp_vendorData,
    });
  };
  readShipmentTermBySearchString(searchString) {
    let shipmentTermData = this.state.shipmentTerms;
    let simpleAutoCompleteList = new Array();
    if (shipmentTermData.length > 0 && shipmentTermData != null) {
      shipmentTermData.map((shipmentTerms) => {
        let simpleItemBean = {
          code: shipmentTerms.code,
          description: shipmentTerms.description,
        };
        simpleAutoCompleteList.push(simpleItemBean);
      });
    }
    let userInput = searchString;

    let filteredSuggestions = new Array();

    filteredSuggestions = simpleAutoCompleteList.filter(
      (simpleAutoCompleteShipmentTermLists) =>
        simpleAutoCompleteShipmentTermLists.code
          .toLowerCase()
          .indexOf(userInput.toLowerCase()) > -1
    );
    this.setState({
      shipmentTermPageListForAutoCompleteList: filteredSuggestions,
    });
  }
  shipmentTermEnterKeyEventHandler = (e) => {
    let temp_vendorData = this.state.vendorData;
    temp_vendorData[e.target.name] = e.target.value;
    this.setState({
      vendorData: temp_vendorData,
      shipmentTermPageListForAutoCompleteList: new Array(),
    });
  };
  onFOBChange = (e) => {
    let fob = e.target.value;
    this.state.showAutoCompleteFOBList = true;

    let temp_vendorData = this.state.vendorData;
    let showAutoCompleteList = this.state.showAutoCompleteFOBList;

    if (isEmpty(fob)) {
      this.state.showAutoCompleteFOBList = false;
      let showAutoCompleteList = this.state.showAutoCompleteFOBList;
      let temp_vendorData = this.state.vendorData;
      temp_vendorData.fOBCity = "";
      let suggestion = [];

      this.setState({
        showAutoCompleteList: showAutoCompleteList,
        vendorData: temp_vendorData,
        fobPageListForAutoCompleteList: suggestion,
      });
    } else if (showAutoCompleteList === true && fob !== "") {
      this.readFOBBySearchString(fob);
    }
    if (e.target.name == "fOBCity") {
      temp_vendorData[e.target.name] = e.target.value;
      let fOBCityList = this.state.fOBCities;
      fOBCityList.map((pdtType) => {
        if (pdtType.code == e.target.value) {
          temp_vendorData["fOBCity"] = pdtType.code;
          this.state.showAutoCompleteFOBList = false;
          let showAutoCompleteList = this.state.showAutoCompleteFOBList;
          this.setState({ showAutoCompleteFOBList: showAutoCompleteList });
        }
      });
    }

    this.setState({
      vendorData: temp_vendorData,
    });
  };
  readFOBBySearchString(searchString) {
    let fobData = this.state.fOBCities;
    let simpleAutoCompleteList = new Array();
    if (fobData.length > 0 && fobData != null) {
      fobData.map((fobs) => {
        let simpleItemBean = { code: fobs.code, description: fobs.description };
        simpleAutoCompleteList.push(simpleItemBean);
      });
    }
    let userInput = searchString;

    let filteredSuggestions = new Array();

    filteredSuggestions = simpleAutoCompleteList.filter(
      (simpleAutoCompleteFOBLists) =>
        simpleAutoCompleteFOBLists.code
          .toLowerCase()
          .indexOf(userInput.toLowerCase()) > -1
    );
    this.setState({ fobPageListForAutoCompleteList: filteredSuggestions });
  }
  fobEnterKeyEventHandler = (e) => {
    let temp_vendorData = this.state.vendorData;
    temp_vendorData[e.target.name] = e.target.value;
    this.setState({
      vendorData: temp_vendorData,
      fobPageListForAutoCompleteList: new Array(),
    });
  };
  displayAutoCompleteShipmentTermList = (showAutoCompleteList) => {
    this.setState({ showAutoCompleteShipmentTermList: showAutoCompleteList });
  };
  displayAutoCompleteFobList = (showAutoCompleteList) => {
    this.setState({ showAutoCompleteFOBList: showAutoCompleteList });
  };
  onIncoTermChange = (e) => {
    let incoTerm = e.target.value;
    this.state.showAutoCompleteIncoTermList = true;

    let temp_vendorData = this.state.vendorData;
    let showAutoCompleteList = this.state.showAutoCompleteIncoTermList;

    if (isEmpty(incoTerm)) {
      this.state.showAutoCompleteIncoTermList = false;
      let showAutoCompleteList = this.state.showAutoCompleteIncoTermList;
      let temp_vendorData = this.state.vendorData;
      temp_vendorData.incoterm = "";
      let suggestion = [];

      this.setState({
        showAutoCompleteList: showAutoCompleteList,
        vendorData: temp_vendorData,
        incoTermPageListForAutoCompleteList: suggestion,
      });
    } else if (showAutoCompleteList === true && incoTerm !== "") {
      this.readIncoTermBySearchString(incoTerm);
    }
    if (e.target.name == "incoterm") {
      temp_vendorData[e.target.name] = e.target.value;
      let incoTermList = this.state.incoTerms;
      incoTermList.map((pdtType) => {
        if (pdtType.code == e.target.value) {
          temp_vendorData["incoterm"] = pdtType.code;
          this.state.showAutoCompleteIncoTermList = false;
          let showAutoCompleteList = this.state.showAutoCompleteIncoTermList;
          this.setState({ showAutoCompleteIncoTermList: showAutoCompleteList });
        }
      });
    }

    this.setState({
      vendorData: temp_vendorData,
    });
  };
  readIncoTermBySearchString(searchString) {
    let incoTermData = this.state.incoTerms;
    let simpleAutoCompleteList = new Array();
    if (incoTermData.length > 0 && incoTermData != null) {
      incoTermData.map((incoTerms) => {
        let simpleItemBean = {
          code: incoTerms.code,
          description: incoTerms.description,
        };
        simpleAutoCompleteList.push(simpleItemBean);
      });
    }
    let userInput = searchString;

    let filteredSuggestions = new Array();

    filteredSuggestions = simpleAutoCompleteList.filter(
      (simpleAutoCompleteIncoTermLists) =>
        simpleAutoCompleteIncoTermLists.code
          .toLowerCase()
          .indexOf(userInput.toLowerCase()) > -1
    );
    this.setState({ incoTermPageListForAutoCompleteList: filteredSuggestions });
  }
  incoTermEnterKeyEventHandler = (e) => {
    let temp_vendorData = this.state.vendorData;
    temp_vendorData[e.target.name] = e.target.value;
    this.setState({
      vendorData: temp_vendorData,
      incoTermPageListForAutoCompleteList: new Array(),
    });
  };

  displayAutoCompleteIncoTermList = (showAutoCompleteList) => {
    this.setState({ showAutoCompleteIncoTermList: showAutoCompleteList });
  };
  onCurrencyCodeChange = (e) => {
    let currencyCode = e.target.value;
    this.state.showAutoCompleteCurrencyCodeList = true;

    let temp_vendorData = this.state.vendorData;
    let showAutoCompleteList = this.state.showAutoCompleteCurrencyCodeList;

    if (isEmpty(currencyCode)) {
      this.state.showAutoCompleteCurrencyCodeList = false;
      let showAutoCompleteList = this.state.showAutoCompleteCurrencyCodeList;
      let soLine = this.state.vendorData;
      soLine.currencyCode = "";
      let suggestion = [];

      this.setState({
        showAutoCompleteList: showAutoCompleteList,
        vendorData: soLine,
        currencyCodePageListForAutoCompleteList: suggestion,
      });
    } else if (showAutoCompleteList === true && currencyCode !== "") {
      this.readCurrencyCodeBySearchString(currencyCode);
    }
    if (e.target.name == "currencyCode") {
      temp_vendorData["currencyCode"] = e.target.value;
      let currencyCode_List = this.state.currencies;
      currencyCode_List.map((pdtType) => {
        if (pdtType.code == e.target.value) {
          temp_vendorData["currencyCode"] = pdtType.code;
          this.state.showAutoCompleteCurrencyCodeList = false;
          let showAutoCompleteList =
            this.state.showAutoCompleteCurrencyCodeList;
          this.setState({ showAutoCompleteList: showAutoCompleteList });
        }
      });
    }
    this.setState({ vendorData: temp_vendorData });
  };
  readCurrencyCodeBySearchString(searchString) {
    let currencyCodeData = this.state.currencies;
    let simpleAutoCompleteList = new Array();
    if (currencyCodeData.length > 0 && currencyCodeData != null) {
      currencyCodeData.map((currencyCodeDatas) => {
        let simpleItemBean = {
          code: currencyCodeDatas.code,
          description: currencyCodeDatas.description,
        };
        simpleAutoCompleteList.push(simpleItemBean);
      });
    }
    let userInput = searchString;

    let filteredSuggestions = new Array();

    filteredSuggestions = simpleAutoCompleteList.filter(
      (simpleAutoCompletecurrencyCodeLists) =>
        simpleAutoCompletecurrencyCodeLists.code
          .toLowerCase()
          .indexOf(userInput.toLowerCase()) > -1
    );
    this.setState({
      currencyCodePageListForAutoCompleteList: filteredSuggestions,
    });
  }
  currencyCodeEnterKeyEvent = (e) => {
    let temp_vendorData = this.state.vendorData;
    let currencyCode = e.target.value;

    temp_vendorData["currencyCode"] = e.target.value;
    let CurrencyCode_List = this.state.currencies;
    let CurrencyCodeBean = null;
    CurrencyCode_List.map((pdtType) => {
      if (pdtType.code == e.target.value) {
        CurrencyCodeBean = pdtType;
      }
    });
    if (!isEmpty(CurrencyCodeBean)) {
      let temp_vendorData = this.state.vendorData;
      temp_vendorData.currencyCode = CurrencyCodeBean.code;
      this.setState({
        vendorData: temp_vendorData,
        currencyCodePageListForAutoCompleteList: new Array(),
      });
    }
  };
  displayAutoCompleteCurrencyList = (showAutoCompleteList) => {
    this.setState({ showAutoCompleteCurrencyCodeList: showAutoCompleteList });
  };
  getEmptyView() {
    return <div></div>;
  }
  getNodeList = () => {
     const moduleVersion   = ConfigManager.getModuleVersion();
    let vendorData = this.state.vendorData;
    let nodeList = [];
    let headerObject = this.getEmptyView();
    let vendorFactoryObject = this.getEmptyView();
    let headerNode = new NodeData("headerView", "Header", headerObject, <AlignStartVertical size={16} /> );
    let vendorFactoryNode = new NodeData(
      "vendorFactoryView",
      "VendorFactory",
      vendorFactoryObject,
        <Factory size={16} /> 
    );
    let vendorPurchaseDetailsNode = new NodeData(
      "vendorPurchaseDetailsView",
      "Vendor Purchase Details",
      vendorFactoryObject,
       <ShoppingBag size={16} /> 
    );
    nodeList["headerView"] = headerNode;
    if (vendorData.isFetched) {
    if (moduleVersion !== "version_3") {

      
      nodeList["vendorFactoryView"] = vendorFactoryNode;
      if (!this.state.is3PL) {
      nodeList["vendorPurchaseDetailsView"] = vendorPurchaseDetailsNode;
      }
    }
    }
    this.setState({ nodeList: nodeList });
  };

  nodeOnSelect = (selectedNode) => {
    if (selectedNode == "headerView") {
      this.setVendorHeaderView();
    } else if (selectedNode == "vendorFactoryView") {
      this.setVendorFactoryListView();
    }
    else if (selectedNode == "vendorPurchaseDetailsView") {
      this.setPurchaseDetailsView();
    }
    this.setState({ selectedNodeKey: selectedNode });
  };

  setVendorHeaderView = () => {
    this.closeAllNodeViews();
    this.setState({
      isShowSaveButton: true,
      isVendorEntryFormOpen: true,
      isVendorListFormOpen: false,
      isVendorFactoryListOpened: false,
      isVendorFactoryEntryOpened: false,
      isVendorPurchaseDetailsOpened: false,
    });
  };
  setVendorFactoryListView = () => {
    this.closeAllNodeViews();
    this.setState({
      isShowSaveButton: false,
      isVendorEntryFormOpen: false,
      isVendorListFormOpen: false,
      isVendorFactoryListOpened: true,
      isVendorFactoryEntryOpened: false,
      isVendorPurchaseDetailsOpened: false,
    });
  };
  closeAllNodeViews = () => {
    this.setState({
      isVendorEntryFormOpen: false,
      isVendorListFormOpen: false,
      isVendorFactoryListOpened: false,
      isVendorFactoryEntryOpened: false,
      isVendorPurchaseDetailsOpened: false,
    });
  };
  setPurchaseDetailsView = () => {
    this.closeAllNodeViews();
    this.setState({
      isShowSaveButton: false,
      isVendorEntryFormOpen: false,
      isVendorListFormOpen: false,
      isVendorFactoryListOpened: false,
      isVendorFactoryEntryOpened: false,
      isVendorPurchaseDetailsOpened: true,
    });
  }
  showVendorList = () => {
    this.setState({
      isVendorListFormOpen: true,
      isVendorEntryFormOpen: false,
    });
  };
  loadVendorPage = () => {
    this.setState({
      isLoading: true,
    });
    let requestInput = new RestVendorListRequest();
    requestInput.pageInput = this.state.pageList;
    requestInput.searchCriteria = this.state.criteria;
    if (SecurityAccessManager.VendorMaintenanceView_IsAccessible()) {
      VendorService.getVendorPageList(
        requestInput,
        this.loadVendorResponse,
        this.loadVendorError
      );
    } else {
      let errMsg = "Access Denied";
      let errList = [];
      errList.push(errMsg);

      this.setState({
        alertMessage: errList,
        alertType: "danger",
        isShowAlert: true,
      });
    }
  };
  loadVendorResponse = (response) => {
    const vendor_list = response.data.vendorPageList.vendors;
    let pageList = this.state.pageList;
    pageList.totalCount = response.data.vendorPageList.totalCount;
    pageList.currentPage = response.data.vendorPageList.currentPage;
    if (vendor_list == null) {
      vendor_list = new Array();
    }
    this.setState({
      vendor_list: vendor_list,
      pageList: pageList,
      isLoading: false,
      loadingText: "",
    });
  };

  loadVendorError = (error) => {
    ShowError("Error :" + error);
  };

  addNewEntry = () => {
    let vendorData = new VendorBean();
    vendorData.companyCode = this.companyCode;
    vendorData.code = NEW_ENTRY;
    vendorData.status = "A";
	vendorData.isActive = true;
    vendorData.divisionCode = "N/A";
    vendorData.currencyCode = "USD";
    // vendorData.vendorCategoryCode = "WHL"; //<---- need to verify
    let addressData = new AddressBean();
    vendorData.address = addressData;
    let pageTitle = this.moduleCaption + " - NEW";

    if (!isEmptyString(this.state.moduleKeyCode)) {
      vendorData.code = this.state.moduleKeyCode;
      if (this.state.moduleKeyCode == NEW_ENTRY) {
        this.isLocked = false;
      } else {
        this.isLocked = true;
      }
    }
    vendorData.createdDate = new Date();
    this.setState({
      vendorData: vendorData,
      addressData: addressData,
      pageTitle: pageTitle,
      isLoading: false,
      loadingText: "",
      selectedNodeKey: "headerView",
      // moduleKeyCode: NEW_ENTRY,
    });
    this.state.vendorData = vendorData;
    this.openEntryForm();
  };
  onCriteriaChange = (e) => {
    let criteria = this.state.criteria;
    criteria["vendorNameContains"] = e.target.value;
    this.setState({ criteria: criteria });
  };
  filterVendors = () => {
    this.loadPage(1);
  };
  resetfilterVendors = () => {
    let criteria = new VendorSearchCriteria();
    criteria.companyCode = this.companyCode;
    this.setState({ criteria: criteria });
    var vendorCodeStartsWith = this.state.criteria.vendorCodeStartsWith;
    var vendorNameContains = this.state.criteria.vendorNameContains;
    var vendorCodeContains = this.state.criteria.vendorCodeContains;
    this.loadPage(1);
  };
  editVendor = (vendorCode) => {
    let readrequest = new RestReadRequest();
    readrequest.companyCode = this.companyCode;
    readrequest.code = vendorCode;
    let isLockRequired = false;
    if (this.props.isSpecialViewMode) {
     isLockRequired = false;
    } else {
     isLockRequired = NEW_ENTRY === vendorCode ? false : true;
    }
    // let isLockRequired = NEW_ENTRY === vendorCode ? false : true;
    // // if (isUpdateReloadflag) isLockRequired = false;
    readrequest.isLockRequired = isLockRequired;
    this.setState({ isLoading: true });
    if (SecurityAccessManager.VendorMaintenance_IsAccessible()) {
      VendorService.initVendorModule(
        readrequest,
        this.readVendorResponse,
        this.readVendorError
      );
    } else {
      let errMsg = "Access Denied";
      let errList = [];
      errList.push(errMsg);

      this.setState({
        alertMessage: errList,
        alertType: "danger",
        isShowAlert: true,
      });
    }
  };
  readVendorResponse = (response) => {
    let errMsg = "";
    if (response.data.lockResponse != null) {
      if (!isEmpty(response.data.lockResponse.errors)) {
        this.showErrorMessage(response.data.lockResponse);
        this.state.isViewMode = true;
      }
    }
    if (response.data.vendorResponse != null) {
      if (response.data.vendorResponse.errors != null) {
        response.data.vendorResponse.errors.map((err) => {
          errMsg = err.messageDescription;
        });
      }
    }

    if (errMsg != "Vendor [" + this.state.moduleKeyCode + "] Not read!") {
      this.showErrorMessage(response.data.vendorResponse);
    }
    if (response.data.success) {
      if (response.data.vendorResponse.vendor != null) {
        let vendorData = new VendorBean();
        vendorData = response.data.vendorResponse.vendor;
        let addressData = new AddressBean();
        addressData = vendorData.address;

        let pageTitle = this.moduleCaption + " - EDIT";
        let moduleKeyCode = vendorData.code;
        this.state.vendorData = vendorData;
        this.setState({
          vendorData: vendorData,
          addressData: addressData,
          pageTitle: pageTitle,
          isLoading: false,
          loadingText: "",
          moduleKeyCode: moduleKeyCode,
          isShowNodes: true,
          selectedNodeKey: "headerView",
        });
        this.isLocked = true;
        this.getNodeList();
        this.openEntryForm();
      } else {
        this.addNewEntry();
      }
    }
  };
  readVendorError = (error) => {
    ShowError("Error" + error);
  };
  lockVendor = (code) => {
    let request = new RestEntityUnLockRequest();
    request.companyCode = this.companyCode;
    request.entityCode = code;
    if (SecurityAccessManager.VendorMaintenance_IsAccessible()) {
      VendorService.lockVendor(
        request,
        this.lockVendorResponse,
        this.lockVendorError
      );
    } else {
      let errMsg = "Access Denied";
      let errList = [];
      errList.push(errMsg);

      this.setState({
        alertMessage: errList,
        alertType: "danger",
        isShowAlert: true,
      });
    }
  };
  lockVendorResponse = (response) => { };
  lockVendorError = (error) => {
    ShowError("Error : ", error);
  };
  unlockVendor = (code) => {
    let request = new RestEntityUnLockRequest();
    request.companyCode = this.companyCode;
    request.entityCode = code;
    if (SecurityAccessManager.VendorMaintenance_IsAccessible()) {
      VendorService.unLockVendor(
        request,
        this.unlockVendorResponse,
        this.unlockVendorError
      );
    } else {
      let errMsg = "Access Denied";
      let errList = [];
      errList.push(errMsg);

      this.setState({
        alertMessage: errList,
        alertType: "danger",
        isShowAlert: true,
      });
    }
  };
  unlockVendorResponse = (response) => {
    if (!isEmpty(response.data)) {
      if (response.data.isSuccess) {
        if (this.isLocked) {
          this.editVendor(this.code);
        } else {
          this.isLocked = false;
        }
      } else {
        // this.isLocked = false; optional
        if (!this.state.isReseted) this.showErrorMessage(response.data);
      }
    }
  };
  unlockVendorError = (error) => {
    ShowError("Error : ", error);
  };
  validateVendor = (vendorData) => {
    let isValidVendorData = false;
    let err_list = [];
    let errorMessage = "";
    if (vendorData == null) {
      let errMsg = "Invalid data ";
      errorMessage = errorMessage + errMsg;
      err_list.push(errMsg);
    } else {
      if (isEmptyString(vendorData.description)) {
        let errMsg = "Vendor Name is Required";
        errorMessage = errorMessage + errMsg;
        err_list.push(errMsg);
      }
    }
    if (err_list.length > 0) {
      isValidVendorData = false;
      this.setState({ errorList: err_list });

      this.setState({
        alertMessage: err_list,
        alertType: "danger",
        isShowAlert: true,
        isShowPopupAlert: false,
      });
    } else {
      isValidVendorData = true;
      this.setState({ isShowAlert: false, isShowPopupAlert: false });
    }

    return isValidVendorData;
  };
  saveVendor = (vendorData, addressData) => {
    this.setState({
      isLoading: true,
      loadingText: "Saving ..",
    });
    vendorData.address = addressData;

    if (vendorData.isFetched) {
      if (SecurityAccessManager.VendorMaintenanceEdit_IsAccessible()) {
        VendorService.updateVendor(
          vendorData,
          this.updateVendorResponse,
          this.saveVendorError
        );
      } else {
        let errMsg = "Access Denied";
        let errList = [];
        errList.push(errMsg);

        this.setState({
          alertMessage: errList,
          alertType: "danger",
          isShowAlert: true,
          isLoading: false,
          loadingText: "",
        });
      }
    } else {
      let isValidLine = false;
      isValidLine = this.validateVendor(vendorData);
      if (isValidLine) {
        if (SecurityAccessManager.VendorMaintenanceCreate_IsAccessible()) {
          VendorService.saveVendor(
            vendorData,
            this.saveVendorResponse,
            this.saveVendorError
          );
        } else {
          let errMsg = "Access Denied";
          let errList = [];
          errList.push(errMsg);

          this.setState({
            alertMessage: errList,
            alertType: "danger",
            isShowAlert: true,
            isLoading: false,
            loadingText: "",
          });
        }
      } else {
        this.setState({
          isLoading: false,
          loadingText: "",
        });
      }
      // } else {
      //   let errMsg = "Vendor Name Is Required";
      //   let errList = [];
      //   errList.push(errMsg);
      //   this.setState({
      //     alertMessage: errList,
      //     alertType: "danger",
      //     isShowAlert: true,
      //   });
      // }
    }
  };
  saveVendorResponse = (response) => {
    this.handleresponse(response.data);
    let vendorData = new VendorBean();
    if (response.data != null) {
      if (response.data.success) {
        if (response.data.vendor != null) {
          vendorData = response.data.vendor;

          let pageTitle = this.moduleCaption + " - EDIT";
          this.setState({
            vendorData: vendorData,
            pageTitle: pageTitle,
            isLoading: false,
            loadingText: "",
          });

          if (!this.isLocked) {
            this.editVendor(vendorData.code, false);
          } else {
            this.code = vendorData.code;
            this.unlockVendor(vendorData.code);
          }
        }
      }
    }
    this.setState({
      isLoading: false,
      loadingText: "",
    });
  };
  updateVendorResponse = (response) => {
    this.handleresponse(response.data);
    let vendorData = new VendorBean();
    if (response.data != null) {
      if (response.data.success) {
        if (response.data.vendor != null) {
          vendorData = response.data.vendor;

          let pageTitle = this.moduleCaption + " - EDIT";
          this.setState({
            vendorData: vendorData,
            pageTitle: pageTitle,
            isLoading: false,
            loadingText: "",
          });
          // this.unlockVendor(vendorData.code);
          // this.editVendor(vendorData.code, false);

          if (this.isLocked) {
            this.code = vendorData.code;
            this.unlockVendor(vendorData.code);
          }
        }
      }
    }
    this.setState({
      isLoading: false,
      loadingText: "",
    });
  };

  saveVendorError = (error) => {
    ShowError("Error:" + error);
  };

  openEntryForm = () => {
    this.closeAllNodeViews();
    this.getNodeList();
    this.setState({
      isVendorListFormOpen: false,
      isVendorEntryFormOpen: true,
      isShowSaveButton: true,
      isShowClearCriteriaButton: false,
      isVendorFactoryEntryOpened: false,
      isVendorFactoryListOpened: false,
      isVendorPurchaseDetailsOpened: false,
      isShowClearErrorButton: true,
      isShowBackButton: true,
      isShowNodes: true,
      isShowModuleSearchContainer: true,
      isResetView: false,
    });
    if (this.state.isSpecialViewMode == false) {
      this.setState({
        isResetView: true,
        isMaintenanceMode: true,
        isVendorListFormOpen: false,
        disabled: false,
        isDisableNodeFields: false,
        isDisabledFields: false,
      });
      if (this.state.isViewMode) {
        let pageTitle = this.moduleCaption + " - VIEW";
        this.setState({
          isDisabledFields: true,
          disabled: true,
          pageTitle: pageTitle,
        });
      }
    } else {
      this.setState({
        isDisabledFields: true,
        disabled: true,
      });
    }
    if (this.state.moduleKeyCode != NEW_ENTRY) {
      this.setState({ disabled: true });
    }
  };
  closeEntryForm = () => {
    this.clearError();
    this.closeAllNodeViews();
    let pageTitle = this.moduleCaption;
    this.setState({
      isVendorListFormOpen: true,
      isVendorEntryFormOpen: false,
      isShowSaveButton: false,
      isShowClearCriteriaButton: false,
      isShowBackButton: false,
      isVendorFactoryEntryOpened: false,
      isVendorFactoryListOpened: false,
      isVendorPurchaseDetailsOpened: false,
      isShowClearErrorButton: false,
      pageTitle: pageTitle,
      isShowNodes: false,
      isShowModuleSearchContainer: false,
      moduleKeyCode: NEW_ENTRY,
      disabled: false,
      isResetView: false,
      isMaintenanceMode: false,
      isViewMode: false,
      isSpecialViewMode: false,
      isDisabledFields: false,
    });
    // let vendorCode = this.state.vendorData.code;
    //this.unlockVendor(vendorCode);
  };
  closeVendorFactoryEntryForm = () => {
    // this.getNodeList();
    this.clearError();
    let pageTitle = this.moduleCaption;
    this.setState({
      isVendorFactoryListOpened: true,
      isVendorFactoryEntryOpened: false,
      isShowSaveButton: false,
    });
    this.getNodeList();
  };
  editVendorFactory = (vendorFactoryCode) => {
    this.clearError();
    let isVendorFactoryListOpened = false;
    let isVendorFactoryEntryOpened = true;
    let disableVendorFactoryFields = true;
    this.setState({
      isVendorFactoryListOpened: isVendorFactoryListOpened,
      isVendorFactoryEntryOpened: isVendorFactoryEntryOpened,
      isShowSaveButton: true,
      disableVendorFactoryFields: disableVendorFactoryFields,
    });
    this.readVendorFactory(vendorFactoryCode);
  };
  //   getvendorFactoryView() {
  //     return (
  //       <div>
  //         {this.state.isVendorFactoryListOpened && (
  //           <Button
  //           id="fabric_Add_Button"
  //                       className="enterFocus"
  //                       size="sm1"
  //                       bssize="large"
  //  onClick={() => this.addNewVendorFactory()}>
  //             {" "}
  //             Add ShipTo{" "}
  //           </Button>
  //         )}
  //         {this.state.isVendorFactoryListOpened && (
  //           <VendorFactoryListForm
  //             vendorFactoryList={this.state.vendorFactoryList}
  //             editVendorFactory={this.editVendorFactory}
  //             vendorData={this.state.vendorData}
  //           />
  //         )}

  //         {this.state.isVendorFactoryEntryOpened && (
  //           <VendorFactoryEntryForm
  //             vendorFactoryData={this.state.currentVendorFactory}
  //             vendorFactoryAddressData={this.state.vendorFactoryAddressData}
  //             warehouses={this.state.warehouses}
  //             saveVendorFactory={this.saveVendorFactory}
  //             isDisabledFields={this.state.isDisabledFields}
  //           />
  //         )}
  //       </div>
  //     );
  //   }

  onVendorFactoryChange = (e) => {
    let vendorFactoryData = this.state.vendorFactoryData;
    vendorFactoryData[e.target.name] = e.target.value;
  };
  filterVendorFactory = (vendorCode) => {
    this.loadVendorFactoryListPage(vendorCode);
  };
  loadVendorFactoryListPage = (vendorCode) => {
    let criteria = new VendorFactorySearchCriteria();
    criteria.companyCode = this.companyCode;
    criteria.vendorCode = vendorCode;
    let pageInput = new PageListBean();
    pageInput.pageSize = 50;
    pageInput.currentPage = 1;
    let requestInput = new RestVendorFactoryListRequest();
    requestInput.pageInput = this.state.pageList;
    requestInput.searchCriteria = criteria;
    if (SecurityAccessManager.VendorMaintenanceView_IsAccessible()) {
      VendorService.getVendorFactoryPageList(
        requestInput,
        this.loadVendorFactoryPageResponse,
        this.loadVendorFactoryPageError
      );
    } else {
      let errMsg = "Access Denied";
      let errList = [];
      errList.push(errMsg);

      this.setState({
        alertMessage: errList,
        alertType: "danger",
        isShowAlert: true,
      });
    }
  };
  loadVendorFactoryPageResponse = (response) => {
    const resultvendorFactoryList =
      response.data.vendorFactoryPageList.vendorFactories;
    let pageList = this.state.pageList;
    pageList.totalCount = response.data.vendorFactoryPageList.totalCount;
    pageList.currentPage = response.data.vendorFactoryPageList.currentPage;
    if (resultvendorFactoryList == null) {
      resultvendorFactoryList = new Array();
    }
    this.setState({
      vendorFactoryList: resultvendorFactoryList,
      factoryPageList: pageList,
    });
  };
  loadVendorFactoryPageError = (error) => {
    ShowError("Error:" + error);
  };

  readVendorFactory = (vendorFactoryCode) => {
    let readRequestBean = new RestVendorFactoryReadRequest();
    readRequestBean.companyCode = this.companyCode;
    readRequestBean.vendorCode = this.state.vendorData.code;
    readRequestBean.code = vendorFactoryCode;
    if (SecurityAccessManager.VendorMaintenance_IsAccessible()) {
      VendorService.readVendorFactory(
        readRequestBean,
        this.readVendorFactoryResponse,
        this.readVendorFactoryError
      );
    } else {
      let errMsg = "Access Denied";
      let errList = [];
      errList.push(errMsg);

      this.setState({
        alertMessage: errList,
        alertType: "danger",
        isShowAlert: true,
      });
    }
  };
  readVendorFactoryResponse = (response) => {
    if (response.data.success) {
      this.setState({
        currentVendorFactory: response.data.vendorFactory,
        vendorFactoryAddressData: response.data.vendorFactory.address,
      });
    }
  };
  readVendorFactoryError = (error) => {
    ShowError("Error:" + error);
  };

  saveVendorFactory = (vendorFactoryData, addressData) => {
    vendorFactoryData.address = addressData;
    let vendor_Data = this.state.vendorData;
    // this.lockVendor(vendor_Data.code);
    if (vendorFactoryData.isFetched) {
      if (SecurityAccessManager.VendorMaintenance_IsAccessible()) {
        VendorService.updateVendorFactory(
          vendorFactoryData,
          this.saveVendorFactoryResponse,
          this.saveVendorFactoryError
        );
      } else {
        let errMsg = "Access Denied";
        let errList = [];
        errList.push(errMsg);

        this.setState({
          alertMessage: errList,
          alertType: "danger",
          isShowAlert: true,
        });
      }
    } else {
      if (SecurityAccessManager.VendorMaintenance_IsAccessible()) {
        VendorService.saveVendorFactory(
          vendorFactoryData,
          this.saveVendorFactoryResponse,
          this.saveVendorFactoryError
        );
      } else {
        let errMsg = "Access Denied";
        let errList = [];
        errList.push(errMsg);

        this.setState({
          alertMessage: errList,
          alertType: "danger",
          isShowAlert: true,
        });
      }
    }
  };
  saveVendorFactoryResponse = (response) => {
    this.handleresponse(response.data);
    if (response.data.success) {
      this.clearError();
      this.closeVendorFactoryEntryForm();
      this.setVendorFactoryListView();
    }
  };
  saveVendorFactoryError = (error) => {
    ShowError("Error:" + error);
  };

  addNewVendorFactory = (e) => {
    if (e.detail <= 1) {
      let vendorFactoryData = new VendorFactoryBean();
      vendorFactoryData.companyCode = this.companyCode;
      vendorFactoryData.code = NEW_ENTRY;
      vendorFactoryData.status = "A";
      vendorFactoryData.currencyCode = "USD";
      let vendorCode = this.state.vendorData.code;
      vendorFactoryData.vendorCode = vendorCode;
      vendorFactoryData.shipViaCode = "FEDEX";

      let addressData = new AddressBean();
      vendorFactoryData.address = addressData;
      let vendorFactoryAddressData = vendorFactoryData.address;
      let pageTitle = this.moduleCaption + " - NEW";
      this.setState({
        currentVendorFactory: vendorFactoryData,
        pageTitle: pageTitle,
        vendorFactoryAddressData: vendorFactoryAddressData,
        disableVendorFactoryFields: false,
      });
      this.openNewVendorFactoryEntryForm();
    }
  };
  openNewVendorFactoryEntryForm = () => {
    this.setState({
      isShowSaveButton: true,
      isVendorFactoryListOpened: false,
      isVendorFactoryEntryOpened: true,
      isShowSaveButton: true,
      isShowClearCriteriaButton: false,
      isShowClearErrorButton: true,
      isShowBackButton: true,
    });
    this.getNodeList();
  };
  displayAutoCompleteCityList = (showAutoCompleteList) => {
    this.setState({ showAutoCompleteCityList: showAutoCompleteList });
  };

  displayAutoCompleteCountryCodeList = (showAutoCompleteList) => {
    this.setState({ showAutoCompleteCountryCodeList: showAutoCompleteList });
  };
  displayAutoCompleteStateList = (showAutoCompleteList) => {
    this.setState({ showAutoCompleteStateList: showAutoCompleteList });
  };
  displayAutoCompleteCountryList = (showAutoCompleteList) => {
    this.setState({ showAutoCompleteCountryList: showAutoCompleteList });
  };
  closeModalCallBack = (isOpen) => {
    this.setState({
      isShowVendorOnOrderInq: false,
      isShowVendorPurchaseHistoryInq: false,
      moduleForPopup: [],
    });
  };
  onPopupModalExit = () => {
    this.closeModalCallBack(false);
  };
  openVendorOnOrderInq = (code) => {
    if (code !== "" && code !== undefined && code !== NEW_ENTRY) {
      this.setState({
        isShowVendorOnOrderInq: true,
        moduleForPopup: (
          <PopupVendorOnOrderInq
            vendorCode={code}
            onModuleExit={this.onPopupModalExit}
          />
        ),
      });
    }
  };
  openVendorPurchaseHistoryInq = (code) => {
    if (code !== "" && code !== undefined && code !== NEW_ENTRY) {
      this.setState({
        isShowVendorPurchaseHistoryInq: true,
        moduleForPopup: (
          <PopupVendorPurchaseHistoryInq
            vendorCode={code}
            onModuleExit={this.onPopupModalExit}
          />
        ),
      });
    }
  };
  backToFactoryList = () => {
    this.setVendorFactoryListView();
    this.setState({
      currentVendorFactory: new VendorFactoryBean(),
      vendorFactoryAddressData: new AddressBean(),
    });
  };
  getHeaderView() {
    return (
      <VendorEntryForm
        {...this.state}
        vendorNameRef={this.vendorNameRef}
        setFocus={this.setFocus}
        closeEntryForm={this.closeEntryForm}
        saveVendor={this.saveVendor}
        showVendorList={this.showVendorList}
        onLocationChange={this.onLocationChange}
        locationEnterKeyEventHandler={this.locationEnterKeyEventHandler}
        displayAutoCompleteLocationList={this.displayAutoCompleteLocationList}
        showAutoCompleteLocationList={this.state.showAutoCompleteLocationList}
        locationPageListForAutoCompleteList={
          this.state.locationPageListForAutoCompleteList
        }
        onVendorTermChange={this.onVendorTermChange}
        vendorTermEnterKeyEventHandler={this.vendorTermEnterKeyEventHandler}
        displayAutoCompleteBuyingTermsList={
          this.displayAutoCompleteBuyingTermsList
        }
        vendorTermPageListForAutoCompleteList={
          this.state.vendorTermPageListForAutoCompleteList
        }
        onCityChange={this.onCityChange}
        cityEnterKeyEvent={this.cityEnterKeyEvent}
        displayAutoCompleteCityList={this.displayAutoCompleteCityList}
        onCountryChange={this.onCountryChange}
        countryEnterKeyEvent={this.countryEnterKeyEvent}
        displayAutoCompleteCountryCodeList={
          this.displayAutoCompleteCountryCodeList
        }
        displayAutoCompleteCountryList={this.displayAutoCompleteCountryList}
        onStateChange={this.onStateChange}
        onCountryCodeChange={this.onCountryCodeChange}
        countryCodeEnterKeyEvent={this.countryCodeEnterKeyEvent}
        stateEnterKeyEvent={this.stateEnterKeyEvent}
        displayAutoCompleteStateList={this.displayAutoCompleteStateList}
        onShipViaChange={this.onShipViaChange}
        shipViaEnterKeyEvent={this.shipViaEnterKeyEvent}
        displayAutoCompleteShipViaList={this.displayAutoCompleteShipViaList}
        onCurrencyCodeChange={this.onCurrencyCodeChange}
        currencyCodeEnterKeyEvent={this.currencyCodeEnterKeyEvent}
        displayAutoCompleteCurrencyList={this.displayAutoCompleteCurrencyList}
        onFOBChange={this.onFOBChange}
        fobEnterKeyEventHandler={this.fobEnterKeyEventHandler}
        fobPageListForAutoCompleteList={
          this.state.fobPageListForAutoCompleteList
        }
        showAutoCompleteFOBList={this.state.showAutoCompleteFOBList}
        displayAutoCompleteShipmentTermList={
          this.displayAutoCompleteShipmentTermList
        }
        onIncoTermChange={this.onIncoTermChange}
        incoTermEnterKeyEventHandler={this.incoTermEnterKeyEventHandler}
        incoTermPageListForAutoCompleteList={
          this.state.incoTermPageListForAutoCompleteList
        }
        showAutoCompleteIncoTermList={this.state.showAutoCompleteIncoTermList}
        displayAutoCompleteIncoTermList={this.displayAutoCompleteIncoTermList}
        displayAutoCompleteFobList={this.displayAutoCompleteFobList}
        onShipmentTermChange={this.onShipmentTermChange}
        shipmentTermEnterKeyEventHandler={this.shipmentTermEnterKeyEventHandler}
        shipmentTermPageListForAutoCompleteList={
          this.state.shipmentTermPageListForAutoCompleteList
        }
        showAutoCompleteShipmentTermList={
          this.state.showAutoCompleteShipmentTermList
        }
        openVendorOnOrderInq={this.openVendorOnOrderInq}
        openVendorPurchaseHistoryInq={this.openVendorPurchaseHistoryInq}
        closeModalCallBack={this.closeModalCallBack}
        onCategoryChange={this.onCategoryChange}
        categoryEnterKeyEventHandler={this.categoryEnterKeyEventHandler}
        displayAutoCompleteCategoryList={this.displayAutoCompleteCategoryList}
        onVendorTypeChange={this.onVendorTypeChange}
        vendorTypeEnterKeyEventHandler={this.vendorTypeEnterKeyEventHandler}
        displayAutoCompleteVendorTypeList={
          this.displayAutoCompleteVendorTypeList
        }
      />
    );
  }
  getVendorPurchaseDetailView = () => {
    return (
      <div>
        <VendorPurchaseDetails
          {...this.state}
          vendorData={this.state.vendorData}
          saveVendorFactory={this.saveVendorFactory}
        />
      </div>
    );
  }
  getVendorFactoryListView() {
    return (
      <div>
        <Button
          id="fabric_Add_Button"
          className="enterFocus"
          size="sm1"
          bssize="large"
          onClick={(e) => this.addNewVendorFactory(e)}
          disabled={this.state.isDisabledFields}
        >
          {" "}
          Add Factory{" "}
        </Button>
        <VendorFactoryListForm
          {...this.state}
          editVendorFactory={this.editVendorFactory}
          filterVendorFactory={this.filterVendorFactory}
          readVendorFactory={this.readVendorFactory}
        />
      </div>
    );
  }
  getVendorFactoryEntryView() {
    return (
      <VendorFactoryEntryForm
        {...this.state}
        vendorFactoryData={this.state.currentVendorFactory}
        vendorFactoryAddressData={this.state.vendorFactoryAddressData}
        saveVendorFactory={this.saveVendorFactory}
        readVendorFactory={this.readVendorFactory}
        onCityFactoryChange={this.onCityFactoryChange}
        cityFactoryEnterKeyEvent={this.cityFactoryEnterKeyEvent}
        displayAutoCompleteCityList={this.displayAutoCompleteCityList}
        onCountryFactoryChange={this.onCountryFactoryChange}
        countryFactoryEnterKeyEvent={this.countryFactoryEnterKeyEvent}
        displayAutoCompleteCountryCodeList={
          this.displayAutoCompleteCountryCodeList
        }
        displayAutoCompleteCountryList={this.displayAutoCompleteCountryList}
        onStateFactoryChange={this.onStateFactoryChange}
        onCountryCodeFactoryChange={this.onCountryCodeFactoryChange}
        countryCodeFactoryEnterKeyEvent={this.countryCodeFactoryEnterKeyEvent}
        stateFactoryEnterKeyEvent={this.stateFactoryEnterKeyEvent}
        displayAutoCompleteStateList={this.displayAutoCompleteStateList}
        onShipViaFactoryChange={this.onShipViaFactoryChange}
        shipViaFactoryEnterKeyEvent={this.shipViaFactoryEnterKeyEvent}
        displayAutoCompleteShipViaList={this.displayAutoCompleteShipViaList}
        onCurrencyCodeFactoryChange={this.onCurrencyCodeFactoryChange}
        currencyCodeFactoryEnterKeyEvent={this.currencyCodeFactoryEnterKeyEvent}
        displayAutoCompleteCurrencyList={this.displayAutoCompleteCurrencyList}
        onFOBFactoryChange={this.onFOBFactoryChange}
        fobFactoryEnterKeyEventHandler={this.fobFactoryEnterKeyEventHandler}
        fobPageListForAutoCompleteList={
          this.state.fobPageListForAutoCompleteList
        }
        showAutoCompleteFOBList={this.state.showAutoCompleteFOBList}
        displayAutoCompleteShipmentTermList={
          this.displayAutoCompleteShipmentTermList
        }
        displayAutoCompleteFobList={this.displayAutoCompleteFobList}
        onShipmentTermFactoryChange={this.onShipmentTermFactoryChange}
        shipmentTermFactoryEnterKeyEventHandler={
          this.shipmentTermFactoryEnterKeyEventHandler
        }
        shipmentTermPageListForAutoCompleteList={
          this.state.shipmentTermPageListForAutoCompleteList
        }
        showAutoCompleteShipmentTermList={
          this.state.showAutoCompleteShipmentTermList
        }
        onVendorTermFactoryChange={this.onVendorTermFactoryChange}
        vendorTermFactoryEnterKeyEventHandler={
          this.vendorTermFactoryEnterKeyEventHandler
        }
        displayAutoCompleteBuyingTermsList={
          this.displayAutoCompleteBuyingTermsList
        }
        backToFactoryList={this.backToFactoryList}
      />
    );
  }
  getModuleListView = () => {
    let vendorData = this.state.vendorData;
    if (vendorData.code === NEW_ENTRY) {
      this.closeEntryForm();
      this.loadVendorPage();
    } else {
      if (this.isLocked) {
        this.isLocked = false;
        if (!this.state.isViewMode) this.unlockVendor(vendorData.code);
      } else {
        this.isLocked = false;
      }

      this.closeEntryForm();
      this.loadVendorPage();
    }
  };
  onVendorTermFactoryChange = (e) => {
    let vendorTerm = e.target.value;
    this.state.showAutoCompleteVendorTermList = true;

    let temp_vendorFactoryData = this.state.currentVendorFactory;
    let showAutoCompleteList = this.state.showAutoCompleteVendorTermList;

    if (isEmpty(vendorTerm)) {
      this.state.showAutoCompleteVendorTermList = false;
      let showAutoCompleteList = this.state.showAutoCompleteVendorTermList;
      let temp_vendorFactoryData = this.state.currentVendorFactory;
      temp_vendorFactoryData.buyingTermsCode = "";
      let suggestion = [];

      this.setState({
        showAutoCompleteVendorTermList: showAutoCompleteList,
        currentVendorFactory: temp_vendorFactoryData,
        vendorTermPageListForAutoCompleteList: suggestion,
      });
    } else if (showAutoCompleteList === true && vendorTerm !== "") {
      this.readVendorTermBySearchString(vendorTerm);
    }
    if (e.target.name == "buyingTermsCode") {
      temp_vendorFactoryData[e.target.name] = e.target.value;
      let buyingTermsCodeList = this.state.vendorTerms;
      buyingTermsCodeList.map((vendorTerm) => {
        if (vendorTerm.code == e.target.value) {
          temp_vendorFactoryData["buyingTermsCode"] = vendorTerm.code;

          this.state.showAutoCompleteVendorTermList = false;
          let showAutoCompleteList = this.state.showAutoCompleteVendorTermList;
          this.setState({
            showAutoCompleteVendorTermList: showAutoCompleteList,
          });
        }
      });
    }

    this.setState({
      currentVendorFactory: temp_vendorFactoryData,
    });
  };
  vendorTermFactoryEnterKeyEventHandler = (e) => {
    let temp_vendorFactoryData = this.state.currentVendorFactory;
    temp_vendorFactoryData[e.target.name] = e.target.value;

    let vendorTermCode_List = this.state.vendorTerms;
    let vendorTermCodeBean = null;
    vendorTermCode_List.map((ln) => {
      if (ln.code == e.target.value) {
        vendorTermCodeBean = ln;
      }
    });
    if (!isEmpty(vendorTermCodeBean)) {
      temp_vendorFactoryData.buyingTermsCode = vendorTermCodeBean.code;

      this.setState({
        currentVendorFactory: temp_vendorFactoryData,
        vendorTermPageListForAutoCompleteList: new Array(),
      });
    }
  };

  onCityFactoryChange = (e) => {
    let city = e.target.value;
    this.state.showAutoCompleteCityList = true;

    let temp_addressData = this.state.vendorFactoryAddressData;
    let showAutoCompleteList = this.state.showAutoCompleteCityList;

    if (isEmpty(city)) {
      this.state.showAutoCompleteCityList = false;
      let showAutoCompleteList = this.state.showAutoCompleteCityList;
      let temp_addressData = this.state.vendorFactoryAddressData;
      temp_addressData.city = "";

      let suggestion = [];

      this.setState({
        showAutoCompleteList: showAutoCompleteList,
        vendorFactoryAddressData: temp_addressData,
        cityPageListForAutoCompleteList: suggestion,
      });
    } else if (showAutoCompleteList === true && city !== "") {
      this.readcityBySearchString(city);
    }
    if (e.target.name == "city") {
      temp_addressData["city"] = e.target.value;
      let city_List = this.state.cities;
      city_List.map((city) => {
        if (city.code == e.target.value) {
          temp_addressData["city"] = city.code;

          this.state.showAutoCompleteCityList = false;
          let showAutoCompleteList = this.state.showAutoCompleteCityList;
          this.setState({ showAutoCompleteList: showAutoCompleteList });
        }
      });
    }
    this.setState({ vendorFactoryAddressData: temp_addressData });
  };
  cityFactoryEnterKeyEvent = (e) => {
    let temp_addressData = this.state.vendorFactoryAddressData;
    let city = e.target.value;

    temp_addressData["city"] = e.target.value;
    let city_List = this.state.cities;
    let cityBean = null;
    city_List.map((city) => {
      if (city.code == e.target.value) {
        cityBean = city;
      }
    });
    if (!isEmpty(cityBean)) {
      let temp_addressData = this.state.vendorFactoryAddressData;
      temp_addressData.city = cityBean.code;

      this.setState({
        vendorFactoryAddressData: temp_addressData,
        cityPageListForAutoCompleteList: new Array(),
      });
    }
  };

  onCountryFactoryChange = (e) => {
    let manufacturingCountryCode = e.target.value;
    this.state.showAutoCompleteCountryList = true;

    let temp_vendorFactoryData = this.state.currentVendorFactory;
    let showAutoCompleteList = this.state.showAutoCompleteCountryList;

    if (isEmpty(manufacturingCountryCode)) {
      this.state.showAutoCompleteCountryList = false;
      let showAutoCompleteList = this.state.showAutoCompleteCountryList;
      let temp_vendorFactoryData = this.state.currentVendorFactory;
      temp_vendorFactoryData.manufacturingCountryCode = "";

      let suggestion = [];

      this.setState({
        showAutoCompleteList: showAutoCompleteList,
        vendorData: temp_vendorFactoryData,
        countryPageListForAutoCompleteList: suggestion,
      });
    } else if (
      showAutoCompleteList === true &&
      manufacturingCountryCode !== ""
    ) {
      this.readcountryBySearchString(manufacturingCountryCode);
    }
    if (e.target.name == "manufacturingCountryCode") {
      temp_vendorFactoryData["manufacturingCountryCode"] = e.target.value;
      let manufacturingCountryCode_List = this.state.countries;
      manufacturingCountryCode_List.map((manufacturingCountryCode) => {
        if (manufacturingCountryCode.code == e.target.value) {
          temp_vendorFactoryData["manufacturingCountryCode"] =
            manufacturingCountryCode.code;

          this.state.showAutoCompleteCountryList = false;
          let showAutoCompleteList = this.state.showAutoCompleteCountryList;
          this.setState({ showAutoCompleteList: showAutoCompleteList });
        }
      });
    }
    this.setState({ currentVendorFactory: temp_vendorFactoryData });
  };
  countryFactoryEnterKeyEvent = (e) => {
    let temp_vendorFactoryData = this.state.currentVendorFactory;
    let manufacturingCountryCode = e.target.value;

    temp_vendorFactoryData["manufacturingCountryCode"] = e.target.value;
    let manufacturingCountryCode_List = this.state.countries;
    let countryBean = null;
    manufacturingCountryCode_List.map((manufacturingCountryCode) => {
      if (manufacturingCountryCode.code == e.target.value) {
        countryBean = manufacturingCountryCode;
      }
    });
    if (!isEmpty(countryBean)) {
      let temp_vendorFactoryData = this.state.currentVendorFactory;
      temp_vendorFactoryData.manufacturingCountryCode = countryBean.code;

      this.setState({
        currentVendorFactory: temp_vendorFactoryData,
        countryPageListForAutoCompleteList: new Array(),
      });
    }
  };

  onCountryCodeFactoryChange = (e) => {
    let country = e.target.value;
    this.state.showAutoCompleteCountryCodeList = true;

    let temp_addressData = this.state.vendorFactoryAddressData;
    let showAutoCompleteList = this.state.showAutoCompleteCountryCodeList;

    if (isEmpty(country)) {
      this.state.showAutoCompleteCountryCodeList = false;
      let showAutoCompleteList = this.state.showAutoCompleteCountryCodeList;
      let temp_addressData = this.state.vendorFactoryAddressData;
      temp_addressData.country = "";

      let suggestion = [];

      this.setState({
        showAutoCompleteCountryCodeList: showAutoCompleteList,
        vendorFactoryAddressData: temp_addressData,
        countryCodePageListForAutoCompleteList: suggestion,
      });
    } else if (showAutoCompleteList === true && country !== "") {
      this.readcountryCodeBySearchString(country);
    }
    if (e.target.name == "country") {
      temp_addressData["country"] = e.target.value;
      let country_List = this.state.countries;
      country_List.map((country) => {
        if (country.code == e.target.value) {
          temp_addressData["country"] = country.code;

          this.state.showAutoCompleteCountryCodeList = false;
          let showAutoCompleteCountryCodeList =
            this.state.showAutoCompleteCountryCodeList;
          this.setState({
            showAutoCompleteCountryCodeList: showAutoCompleteCountryCodeList,
          });
        }
      });
    }
    this.setState({ vendorFactoryAddressData: temp_addressData });
  };
  countryCodeFactoryEnterKeyEvent = (e) => {
    let temp_addressData = this.state.vendorFactoryAddressData;
    let country = e.target.value;
    temp_addressData["country"] = e.target.value;
    let country_List = this.state.countries;
    let countryBean = null;
    country_List.map((country) => {
      if (country.code == e.target.value) {
        countryBean = country;
      }
    });
    if (!isEmpty(countryBean)) {
      let temp_addressData = this.state.vendorFactoryAddressData;
      temp_addressData.country = countryBean.code;

      this.setState({
        vendorFactoryAddressData: temp_addressData,
        countryCodePageListForAutoCompleteList: new Array(),
      });
    }
  };

  onStateFactoryChange = (e) => {
    let state = e.target.value;
    this.state.showAutoCompleteStateList = true;

    let temp_addressData = this.state.vendorFactoryAddressData;
    let showAutoCompleteList = this.state.showAutoCompleteStateList;

    if (isEmpty(state)) {
      this.state.showAutoCompleteStateList = false;
      let showAutoCompleteList = this.state.showAutoCompleteStateList;
      let temp_addressData = this.state.vendorFactoryAddressData;
      temp_addressData.state = "";

      let suggestion = [];

      this.setState({
        showAutoCompleteList: showAutoCompleteList,
        vendorFactoryAddressData: temp_addressData,
        statePageListForAutoCompleteList: suggestion,
      });
    } else if (showAutoCompleteList === true && state !== "") {
      this.readstateBySearchString(state);
    }
    if (e.target.name == "state") {
      temp_addressData["state"] = e.target.value;
      let state_List = this.state.states;
      state_List.map((state) => {
        if (state.code == e.target.value) {
          temp_addressData["state"] = state.code;

          this.state.showAutoCompleteStateList = false;
          let showAutoCompleteList = this.state.showAutoCompleteStateList;
          this.setState({ showAutoCompleteList: showAutoCompleteList });
        }
      });
    }
    this.setState({ vendorFactoryAddressData: temp_addressData });
  };
  stateFactoryEnterKeyEvent = (e) => {
    let temp_addressData = this.state.vendorFactoryAddressData;
    let state = e.target.value;

    temp_addressData["state"] = e.target.value;
    let state_List = this.state.states;
    let stateBean = null;
    state_List.map((state) => {
      if (state.code == e.target.value) {
        stateBean = state;
      }
    });
    if (!isEmpty(stateBean)) {
      let temp_addressData = this.state.vendorFactoryAddressData;
      temp_addressData.state = stateBean.code;

      this.setState({
        vendorFactoryAddressData: temp_addressData,
        statePageListForAutoCompleteList: new Array(),
      });
    }
  };

  onShipViaFactoryChange = (e) => {
    let shipViaCode = e.target.value;
    this.state.showAutoCompleteShipViaList = true;
    let temp_vendorFactoryData = this.state.currentVendorFactory;

    let showAutoCompleteList = this.state.showAutoCompleteShipViaList;

    if (isEmpty(shipViaCode)) {
      this.state.showAutoCompleteShipViaList = false;
      let showAutoCompleteList = this.state.showAutoCompleteShipViaList;

      let temp_vendorFactoryData = this.state.currentVendorFactory;

      temp_vendorFactoryData.shipViaCode = "";

      let suggestion = [];

      this.setState({
        showAutoCompleteList: showAutoCompleteList,
        currentVendorFactory: temp_vendorFactoryData,
        shipViaPageListForAutoCompleteList: suggestion,
      });
    } else if (showAutoCompleteList === true && shipViaCode !== "") {
      this.readShipViaBySearchString(shipViaCode);
    }
    if (e.target.name == "shipViaCode") {
      temp_vendorFactoryData["shipViaCode"] = e.target.value;
      let vendorData_List = this.state.shipVias;
      vendorData_List.map((vendorData) => {
        if (vendorData.code == e.target.value) {
          temp_vendorFactoryData["shipViaCode"] = vendorData.code;

          this.state.showAutoCompleteShipViaList = false;
          let showAutoCompleteList = this.state.showAutoCompleteShipViaList;
          this.setState({ showAutoCompleteList: showAutoCompleteList });
        }
      });
    }
    this.setState({ currentVendorFactory: temp_vendorFactoryData });
  };
  shipViaFactoryEnterKeyEvent = (e) => {
    let temp_vendorFactoryData = this.state.currentVendorFactory;

    let shipViaCode = e.target.value;

    temp_vendorFactoryData["shipViaCode"] = e.target.value;
    let shipViaList = this.state.shipVias;
    let shipViaBean = null;
    shipViaList.map((shipVia_List) => {
      if (shipVia_List.code == e.target.value) {
        shipViaBean = shipVia_List;
      }
    });
    if (!isEmpty(shipViaBean)) {
      let temp_vendorFactoryData = this.state.currentVendorFactory;

      temp_vendorFactoryData.shipViaCode = shipViaBean.code;

      this.setState({
        currentVendorFactory: temp_vendorFactoryData,
        shipViaPageListForAutoCompleteList: new Array(),
      });
    }
  };

  onShipmentTermFactoryChange = (e) => {
    let shipmentTerm = e.target.value;
    this.state.showAutoCompleteShipmentTermList = true;

    let temp_vendorFactoryData = this.state.currentVendorFactory;
    let showAutoCompleteList = this.state.showAutoCompleteShipmentTermList;

    if (isEmpty(shipmentTerm)) {
      this.state.showAutoCompleteShipmentTermList = false;
      let showAutoCompleteList = this.state.showAutoCompleteShipmentTermList;
      let temp_vendorFactoryData = this.state.currentVendorFactory;
      temp_vendorFactoryData.shipmentTermsCode = "";
      let suggestion = [];

      this.setState({
        showAutoCompleteList: showAutoCompleteList,
        currentVendorFactory: temp_vendorFactoryData,
        shipmentTermPageListForAutoCompleteList: suggestion,
      });
    } else if (showAutoCompleteList === true && shipmentTerm !== "") {
      this.readShipmentTermBySearchString(shipmentTerm);
    }
    if (e.target.name == "shipmentTermsCode") {
      temp_vendorFactoryData[e.target.name] = e.target.value;
      let shipmentTermsCodeList = this.state.shipmentTerms;
      shipmentTermsCodeList.map((shipmentTermsCode) => {
        if (shipmentTermsCode.code == e.target.value) {
          temp_vendorFactoryData["shipmentTermsCode"] = shipmentTermsCode.code;

          this.state.showAutoCompleteShipmentTermList = false;
          let showAutoCompleteList =
            this.state.showAutoCompleteShipmentTermList;
          this.setState({
            showAutoCompleteShipmentTermList: showAutoCompleteList,
          });
        }
      });
    }

    this.setState({
      currentVendorFactory: temp_vendorFactoryData,
    });
  };
  shipmentTermFactoryEnterKeyEventHandler = (e) => {
    let temp_vendorFactoryData = this.state.currentVendorFactory;
    temp_vendorFactoryData[e.target.name] = e.target.value;
    this.setState({
      currentVendorFactory: temp_vendorFactoryData,
      shipmentTermPageListForAutoCompleteList: new Array(),
    });
  };

  onFOBFactoryChange = (e) => {
    let fob = e.target.value;
    this.state.showAutoCompleteFOBList = true;
    let temp_vendorFactoryData = this.state.currentVendorFactory;
    let showAutoCompleteList = this.state.showAutoCompleteFOBList;

    if (isEmpty(fob)) {
      this.state.showAutoCompleteFOBList = false;
      let showAutoCompleteList = this.state.showAutoCompleteFOBList;
      let temp_vendorFactoryData = this.state.currentVendorFactory;
      temp_vendorFactoryData.fOBCity = "";
      let suggestion = [];

      this.setState({
        showAutoCompleteList: showAutoCompleteList,
        currentVendorFactory: temp_vendorFactoryData,
        fobPageListForAutoCompleteList: suggestion,
      });
    } else if (showAutoCompleteList === true && fob !== "") {
      this.readFOBBySearchString(fob);
    }
    if (e.target.name == "fOBCity") {
      temp_vendorFactoryData[e.target.name] = e.target.value;
      let fOBCityList = this.state.fOBCities;
      fOBCityList.map((fOBCity) => {
        if (fOBCity.code == e.target.value) {
          temp_vendorFactoryData["fOBCity"] = fOBCity.code;

          this.state.showAutoCompleteFOBList = false;
          let showAutoCompleteList = this.state.showAutoCompleteFOBList;
          this.setState({ showAutoCompleteFOBList: showAutoCompleteList });
        }
      });
    }

    this.setState({
      currentVendorFactory: temp_vendorFactoryData,
    });
  };
  fobFactoryEnterKeyEventHandler = (e) => {
    let temp_vendorFactoryData = this.state.currentVendorFactory;
    temp_vendorFactoryData[e.target.name] = e.target.value;
    this.setState({
      currentVendorFactory: temp_vendorFactoryData,
      fobPageListForAutoCompleteList: new Array(),
    });
  };

  onCurrencyCodeFactoryChange = (e) => {
    let currencyCode = e.target.value;
    this.state.showAutoCompleteCurrencyCodeList = true;

    let temp_vendorFactoryData = this.state.currentVendorFactory;
    let showAutoCompleteList = this.state.showAutoCompleteCurrencyCodeList;

    if (isEmpty(currencyCode)) {
      this.state.showAutoCompleteCurrencyCodeList = false;
      let showAutoCompleteList = this.state.showAutoCompleteCurrencyCodeList;
      let temp_vendorFactoryData = this.state.vendorData;
      temp_vendorFactoryData.currencyCode = "";

      let suggestion = [];

      this.setState({
        showAutoCompleteList: showAutoCompleteList,
        vendorData: temp_vendorFactoryData,
        currencyCodePageListForAutoCompleteList: suggestion,
      });
    } else if (showAutoCompleteList === true && currencyCode !== "") {
      this.readCurrencyCodeBySearchString(currencyCode);
    }
    if (e.target.name == "currencyCode") {
      temp_vendorFactoryData["currencyCode"] = e.target.value;
      let currencyCode_List = this.state.currencies;
      currencyCode_List.map((currencyCode) => {
        if (currencyCode.code == e.target.value) {
          temp_vendorFactoryData["currencyCode"] = currencyCode.code;

          this.state.showAutoCompleteCurrencyCodeList = false;
          let showAutoCompleteList =
            this.state.showAutoCompleteCurrencyCodeList;
          this.setState({ showAutoCompleteList: showAutoCompleteList });
        }
      });
    }
    this.setState({ currentVendorFactory: temp_vendorFactoryData });
  };
  currencyCodeFactoryEnterKeyEvent = (e) => {
    let temp_vendorFactoryData = this.state.currentVendorFactory;
    let currencyCode = e.target.value;

    temp_vendorFactoryData["currencyCode"] = e.target.value;
    let CurrencyCode_List = this.state.currencies;
    let CurrencyCodeBean = null;
    CurrencyCode_List.map((currencyCode) => {
      if (currencyCode.code == e.target.value) {
        CurrencyCodeBean = currencyCode;
      }
    });
    if (!isEmpty(CurrencyCodeBean)) {
      let temp_vendorFactoryData = this.state.currentVendorFactory;
      temp_vendorFactoryData.currencyCode = CurrencyCodeBean.code;

      this.setState({
        currentVendorFactory: temp_vendorFactoryData,
        currencyCodePageListForAutoCompleteList: new Array(),
      });
    }
  };
  resetView = () => {
    let vendor_Data = this.state.vendorData;
    this.state.isReseted = true;
    if (this.isLocked) {
      this.isLocked = false;
      if (!this.state.isViewMode) this.unlockVendor(vendor_Data.code);
    } else {
      this.isLocked = false;
    }

    let vendorData = new VendorBean();
    let currentVendorFactory = new VendorFactoryBean();
    let vendorFactoryAddressData = new AddressBean();
    this.state.moduleKeyCode = NEW_ENTRY;
    this.setState({
      isShowAlert: false,
      isResetModule: true,
      disabled: false,
      selectedNodeKey: "headerView",
      vendorData: vendorData,
      currentVendorFactory: currentVendorFactory,
      vendorFactoryAddressData: vendorFactoryAddressData,
      disableVendorFactoryFields: false,
    });
    this.state.moduleKeyCode = NEW_ENTRY;
    this.code = NEW_ENTRY;
    this.state.isViewMode = false;
    this.hideAlertCallBack();
    this.clearError();
    this.addNewEntry();
  };
  onModuleKeyCodeChange = (e) => {
    let moduleKeyCode = this.state.moduleKeyCode;
    if (e.target.value !== NEW_ENTRY && e.target.value !== "undefined") {
      moduleKeyCode = e.target.value;
    }
    this.setState({ moduleKeyCode: moduleKeyCode });
  };

  onModuleKeyCodeWithCriteriaOnChange = (e) => {
    let moduleKeyCode = this.state.moduleKeyCode;
    if (e.target.value !== NEW_ENTRY && e.target.value !== "undefined") {
      moduleKeyCode = e.target.value.toUpperCase();
    }
    this.setState({ moduleKeyCode: moduleKeyCode });
  };
  selectButtonClick = (e) => {
    this.editVendor(this.state.moduleKeyCode);
    // this.disable();
  };
  disable = () => {
    this.setState({
      disabled: true,
    });
  };

  onModuleKeyContainerButtonClick = () => {
    let vendorData = this.state.vendorData;
    this.unlockVendor(vendorData.code);
    this.editVendor(this.state.moduleKeyCode);
  };
  handleKeyDown = () => {
    this.editVendor(this.state.moduleKeyCode);
  };
  moduleExit = () => {
    let vendorData = this.state.vendorData;
    if (vendorData.code === NEW_ENTRY) {
      this.props.onModuleExit();
    } else {
      if (this.isLocked) {
        this.isLocked = false;
        if (!this.state.isViewMode) this.unlockVendor(vendorData.code);
      } else {
        this.isLocked = false;
      }

      this.props.onModuleExit();
    }
  };
  hideAlertCallBack = (msgType, isDisplayed) => {
    this.setState({ isShowAlert: isDisplayed });
  };
  handleSortingChange = (accessor) => {
    let sortField = accessor;
    let order = this.state.order;
    let sortOrder = accessor === sortField && order === "asc" ? "desc" : "asc";
    this.setState({
      order: sortOrder,
      sortField: sortField,
    });
    this.handleSorting(sortField, sortOrder);
  };
  // sortField => code
  handleSorting = (sortField, sortOrder) => {
    let vendor_list = this.state.vendor_list;
    if (sortField) {
      const sorted = [...vendor_list].sort((a, b) => {
        if (a[sortField] === null) return 1;
        if (b[sortField] === null) return -1;
        if (a[sortField] === null && b[sortField] === null) return 0;
        return (
          a[sortField].toString().localeCompare(b[sortField].toString(), "en", {
            numeric: true,
          }) * (sortOrder === "asc" ? 1 : -1)
        );
      });
      this.setState({ vendor_list: sorted });
    }
  };
  render() {
    return (
      <div>
        {!this.state.isSpecialViewMode ? (
          <AlertToolBox
            alertMsgList={this.state.alertMessage}
            alertErrorType={this.state.alertType}
            isShowAlert={this.state.isShowAlert}
            hideAlertCallBack={this.hideAlertCallBack}
          />
        ) : null}
        <ModuleToolBar
          isShowNewButton={false}
          onNewEntry={() => this.addNewEntry()}
          onModuleExit={() => this.moduleExit()}
          resetView={() => this.resetView()}
          pageTitle={this.state.pageTitle}
          loadingText={this.state.loadingText}
          isLoading={this.state.isLoading}
          isShowModuleSearchContainer={this.state.isShowModuleSearchContainer}
          isMaintenanceMode={this.state.isMaintenanceMode}
          onModuleKeyContainerButtonClick={this.editVendor}
          moduleKeyCode={this.state.moduleKeyCode}
          onModuleKeyCodeChange={this.onModuleKeyCodeChange}
          getModuleListView={this.getModuleListView}
          lookupRequired={true} //for f2 lookup
          lookupHandler={this.state.vendorLookupHandler} //for f2 lookup
          showCriteriaDialog={true} //for f2 lookup
          onModuleKeyCodeWithCriteriaOnChange={
            this.onModuleKeyCodeWithCriteriaOnChange
          }
          disabled={this.state.disabled}
          selectButtonClick={this.selectButtonClick}
          isSpecialViewMode={this.state.isSpecialViewMode}
          isResetView={this.state.isResetView}
        />

        {!this.state.isVendorListFormOpen &&
          this.state.isSpecialViewMode == false &&
          this.state.isViewMode == false && (
            <BaseToolBar
              save={this.save}
              clearError={this.clearError}
              generatePDF={this.generatePDF}
              isShowSaveButton={this.state.isShowSaveButton}
              isShowClearCriteriaButton={this.state.isShowClearCriteriaButton}
              isShowClearErrorButton={this.state.isShowClearErrorButton}
              isShowPDFButton={this.state.isShowPDFReportButton}
              pageTitle={this.state.pageTitle}
              isSpecialViewMode={this.state.isSpecialViewMode}
            />
          )}

        {/* <BaseNotification error_list={this.state.error_list} /> */}

        {this.state.isShowNodes && (
          <BaseNodeBar
            nodeList={this.state.nodeList}
            selectedModuleKey={this.state.selectedNodeKey}
            nodeOnSelect={this.nodeOnSelect}
          />
        )}

        {!this.state.isShowNodes &&
          !this.state.isVendorListFormOpen &&
          !this.state.isVendorFactoryListOpened &&
          !this.state.isVendorFactoryEntryOpened &&
          this.state.isVendorEntryFormOpen &&
          !this.state.isVendorPurchaseDetailsOpened &&
          this.getHeaderView()}
        {this.state.isShowNodes &&
          !this.state.isVendorListFormOpen &&
          !this.state.isVendorFactoryListOpened &&
          !this.state.isVendorFactoryEntryOpened &&
          this.state.isVendorEntryFormOpen &&
          !this.state.isVendorPurchaseDetailsOpened &&
          this.getHeaderView()}
        {this.state.isShowNodes &&
          !this.state.isVendorListFormOpen &&
          this.state.isVendorFactoryListOpened &&
          !this.state.isVendorFactoryEntryOpened &&
          !this.state.isVendorEntryFormOpen &&
          !this.state.isVendorPurchaseDetailsOpened &&
          this.getVendorFactoryListView()}
        {this.state.isShowNodes &&
          !this.state.isVendorListFormOpen &&
          !this.state.isVendorFactoryListOpened &&
          this.state.isVendorFactoryEntryOpened &&
          !this.state.isVendorEntryFormOpen &&
          !this.state.isVendorPurchaseDetailsOpened &&
          this.getVendorFactoryEntryView()}
        {this.state.isShowNodes &&
          !this.state.isVendorListFormOpen &&
          !this.state.isVendorFactoryListOpened &&
          !this.state.isVendorFactoryEntryOpened &&
          !this.state.isVendorEntryFormOpen &&
          this.state.isVendorPurchaseDetailsOpened &&
          this.getVendorPurchaseDetailView()}
          

        {this.state.isVendorListFormOpen &&
          this.state.isSpecialViewMode == false && (
            <VendorListForm
              {...this.state}
              editVendor={this.editVendor}
              filterVendors={this.filterVendors}
              resetfilterVendors={this.resetfilterVendors}
              loadFirst={this.loadFirst}
              loadNext={this.loadNext}
              loadPrevious={this.loadPrevious}
              loadLast={this.loadLast}
              handleSortingChange={this.handleSortingChange}
            />
          )}
      </div>
    );
  }
}

function VendorMaintenanceModule(props) {
  return (
    <div id="moduleContainer" class="module_container">
      <div className="App">
        <VendorList {...props} name="" /> <br />
      </div>
    </div>
  );
}

export default VendorMaintenanceModule;
